(function () {
    var count = 0;
    var getString = '';
    var checkboxes = document.querySelectorAll(".choose_four_products_Laundry > .choose_four_products_varient input[type='checkbox']");

    checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener("click", function () {
            var variantImages = document.querySelectorAll('.variant__img');
            
            var sumList = document.querySelector('.sum_list');
            var firstChild = sumList.querySelector('.sum_list>li:nth-child(1)');
            var allPackageVariants = document.querySelectorAll('.select_your_package_multiple_variants');
            var subscription_plan_content = document.querySelector('.subscription_plan_content');
            checkboxes.forEach(function (otherCheckbox) {
                if (otherCheckbox !== checkbox) {
                    otherCheckbox.checked = false;
                    var forProduct = document.getElementById('forProduct');    
                    forProduct.click();
                }
            });
            if (checkbox.checked) {
               checkbox.closest('.choose_four_products_Laundry').classList.add('activeClass');
            } else {
         
                 firstChild.classList.remove('active');
                // subscription_plan_content.classList.remove('activeClass');
                // allPackageVariants.forEach(function (variant) {
                // variant.classList.remove('activeClass');
                // });
                count--;
                checkbox.closest('.choose_four_products_Laundry').classList.remove('activeClass');
                variantImages.forEach(function (element) {
                    if (element.getAttribute('data') === 'Fresh-Linen,Fragrance-Free') {
                        element.classList.remove("active");
                    }
                });
            }
        });
    });

    var checkboxes = document.querySelectorAll(".choose_four_products_content input[type='checkbox']");

    checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener("click", function () {
            var choose_four_products_Laundry = checkbox.closest(".choose_four_products_Laundry");
            var parentElement = checkbox.closest(".choose_four_products_varient");
            var select_your_package = document.querySelector('.select_your_package');
            var sumList = document.querySelector('.sum_list');
            var firstChild = sumList.querySelector('.sum_list>li:nth-child(1)');
            var variantImages = document.querySelectorAll('.variant__img');
            var variantImages1 = select_your_package.querySelectorAll('.variant__img');
            var img = "https://cdn.shopify.com/s/files/1/0631/6123/7716/files/pink-img.png?v=1709890894";
            document.querySelectorAll(".choose_four_products_varient").forEach(function (element) {
                element.classList.remove("activeClass");
            });
            parentElement.classList.add("activeClass");
            checkboxes.forEach(function (otherCheckbox) {
                var actualMultipleVariantsPrice = document.querySelector('.actual_multiple_variants_price');
                if (otherCheckbox !== checkbox) {
                    otherCheckbox.checked = false;
                } else {
                    var checkboxesItem = document.querySelector('.select_your_package_multiple_variants:nth-child(2) .checkboxes__item');
                    checkboxesItem.click();
                    count++;
                    var dataValue = checkbox.getAttribute('data');
                    document.getElementById("dynamic_text_change").innerHTML="- " + dataValue;
                    var dataValuecurrent = checkbox.getAttribute('data');
                    var first_trigger = document.getElementById("first_trigger");
                    if (first_trigger) {
                        var isChecked = first_trigger.getAttribute("checked");
                        if (!isChecked || isChecked.toLowerCase() !== "checked") {
                            first_trigger.checked = true;
                            console.log("Checkbox checked programmatically.");
                        } else {
                            console.log("Checkbox is already checked.");
                        }
                    } else {
                        console.log("Checkbox not found.");
                    }
                    variantImages.forEach(function (element) {
                    
                    if (element.getAttribute('data') === 'Fresh-Linen,Fragrance-Free') {
                    
                    element.classList.add("active");
                    }
                    });
                  var laundary_img = document.querySelector('.laundary_img');
      
                  if(dataValuecurrent == 'Fragrance-Free'){
                    laundary_img.classList.add('active');
                    var imgElements = document.querySelectorAll('.changeVarientImage2');
                    imgElements.forEach(function (imgElement) {
                    imgElement.style.display = 'block';
                    });
                    var imgElements = document.querySelectorAll('.changeVarientImage1');
                    imgElements.forEach(function (imgElement) {
                    imgElement.style.display = 'none';
                    });
                  }else if(dataValuecurrent == 'Fresh-Linen'){
                    laundary_img.classList.remove('active');
                    var imgElements = document.querySelectorAll('.changeVarientImage2');
                    imgElements.forEach(function (imgElement) {
                    imgElement.style.display = 'none';
                    });
                    var imgElements = document.querySelectorAll('.changeVarientImage1');
                    imgElements.forEach(function (imgElement) {
                    imgElement.style.display = 'block';
                    });
                  }else{
                    laundary_img.classList.remove('active');
                  }
                    var cstmTargetElements = document.querySelectorAll('.saving_20_off');
                    cstmTargetElements.forEach(function (element) {
                        if (element.classList.contains('activeClass')) {
                            var dataValue = element.getAttribute('data-prop');
                            console.log('cstm-target has activeClass', dataValue);

                        } else {

                            variantImages.forEach(function (element) {

                                if (element.getAttribute('data') === 'Fresh-Linen,Fragrance-Free') {

                                    element.classList.add("active");
                                    var imgSrc = '';

                                    var imgElement = checkbox.closest('.choose_four_products_varient').querySelector('.variant__img img');
                                    imgSrc = imgElement.getAttribute('src');
                                    var imgElement = element.querySelector('.variant__img img');

                                    // imgElement.setAttribute('src', imgSrc);

                                    var allPackageVariants = document.querySelectorAll('.select_your_package_multiple_variants');
                                    allPackageVariants.forEach(function (variant) {
                                        variant.classList.remove('activeClass');
                                    });
                                  var clickTrigger = document.getElementById('clickTrigger');
                                  if (clickTrigger) {
                                  clickTrigger.addEventListener('click', function(event) {
                                  event.preventDefault();
                                  });
                                  clickTrigger.click();
                                  }
                                    var subscription_plan_content = document.querySelectorAll('.subscription_plan_content');
                                    subscription_plan_content.forEach(function (variant) {
                                        variant.classList.remove('activeClass');
                                    });

                                    var clickTrigger = document.getElementById('clickTriggerSub');
                                    if (clickTrigger) {
                                        clickTrigger.click();
                                        var subscription_plan_content = document.querySelector('.subscription_plan_content');
                                        if (subscription_plan_content) {
                                            subscription_plan_content.classList.add('activeClass');

                                        } else {

                                        }
                                    } else {

                                    }

                                }
                            });
                            var dataValue = element.getAttribute('data-prop');

                            var activeElements = document.querySelectorAll('.packs.activeClass');

                        }
                    });
                }
                if (checkbox.checked) {
                  var selected_change1=document.querySelector(".selected_change1")
                  if(selected_change1){
                    selected_change1.innerHTML="SAVE 15%"
                  }
                    // select_your_package.classList.add("active");
                  var clickTrigger = document.getElementById('clickTrigger');
                    if (clickTrigger) {
                    clickTrigger.addEventListener('click', function(event) {
                    event.preventDefault();
                    });
                    clickTrigger.click();
                    }
                    firstChild.classList.add('active');
                    var choose_four_products_Laundry = document.querySelectorAll('.cstm-target.choose_four_products_Laundry');
                    
                    // Loop through each element
                    choose_four_products_Laundry.forEach(function(element) {
                    // Add the class "active" to the element
                    element.classList.add('activeClass');
                    });

                } else {
                    getString=""
                  var  selected_change1 = document.querySelector(".selected_change1")
                    if(selected_change1){
                      selected_change1.innerHTML="NEW FORMULA"
                    }
                    var forProduct = document.getElementById('forProduct');
                    forProduct.click();
                    count--;
                      firstChild.classList.remove('active');
                      var first_trigger = document.getElementById("first_trigger");
                      if (first_trigger) {
                      var isChecked = first_trigger.getAttribute("checked");
                      if (!isChecked || isChecked.toLowerCase() !== "checked") {
                      first_trigger.checked = false;
                      console.log("Checkbox checked programmatically.");
                      } else {
                      console.log("Checkbox is already checked.");
                      }
                      } else {
                      console.log("Checkbox not found.");
                    }
                    var clickTrigger = document.getElementById('clickTrigger');
                    if (clickTrigger) {
                    clickTrigger.addEventListener('click', function(event) {
                    event.preventDefault();
                    });
                    clickTrigger.click();
                    }
                    var choose_four_products_Laundry = document.querySelectorAll('.cstm-target.choose_four_products_Laundry');
                    
                    // Loop through each element
                    choose_four_products_Laundry.forEach(function(element) {
                    // Add the class "active" to the element
                    element.classList.remove('activeClass');
                    });
                    variantImages.forEach(function (element) {

                        if (element.getAttribute('data') === 'Fresh-Linen,Fragrance-Free') {

                            element.classList.remove("active");
                        }
                    });
                }
            });
        });
    });

    var saving_20_off_target_checkboxes = document.querySelectorAll(".saving_20_off_target input[type='checkbox']");
    saving_20_off_target_checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener("click", function () {
            var sumList = document.querySelector('.sum_list');
            var select_your_package = document.querySelector('.select_your_package');
            var secondChild = sumList.querySelector('.sum_list>li:nth-child(2)');
            var variantImages = document.querySelectorAll('.variant__img');
            saving_20_off_target_checkboxes.forEach(function (otherCheckbox) {
                if (otherCheckbox !== checkbox) {
                    otherCheckbox.checked = false;
                }
            });

            if (checkbox.checked) {
             
                setTimeout(function () {
                      var clickTrigger = document.getElementById('clickTrigger');
                      if (clickTrigger) {
                      clickTrigger.addEventListener('click', function(event) {
                      event.preventDefault();
                      });
                      clickTrigger.click();
                      }
                }, 1000);
                count++;
                secondChild.classList.add('active');
                select_your_package.classList.add("active");
                checkbox.closest('.saving_20_off_target').classList.add('activeClass');
                var dataValue = checkbox.getAttribute('data');
                console.log(">>aaaaaaaaaaaaaaaaaa>>>>a", dataValue, count)

                variantImages.forEach(function (element) {

                    if (element.getAttribute('data') === dataValue) {

                        element.classList.add("active");
                    }
                });
                var activeContainer = document.querySelector(".select_your_package_multiple_variants.activeClass");
                if (activeContainer || comapare_at_price_multiple_variants_price) {
                    var actualPriceElement = activeContainer.querySelector(".actual_multiple_variants_price");
                    var comapare_at_price_multiple_variants_price = activeContainer.querySelector(".comapare_at_price_multiple_variants_price");

                }
                if (activeContainer) {

                    var variantImages = activeContainer.querySelectorAll('.variant__img');

                    var totalPriceVarientPrice = 0;
                    var totalPriceCompare_atPrice = 0;

                    variantImages.forEach(function (variantImg) {
                        if (variantImg.classList.contains('active')) {

                            var varientPrice = variantImg.getAttribute('varient_price');
                            var varientCompare_atPrice = variantImg.getAttribute('varient_compare_at_price');
                            var numericValueCompare_atPrice = parseFloat(varientCompare_atPrice.replace(/[^\d.]/g, ''));
                            var numericValueVarientPrice = parseFloat(varientPrice.replace(/[^\d.]/g, ''));
                            totalPriceVarientPrice += numericValueVarientPrice;
                            totalPriceCompare_atPrice += numericValueCompare_atPrice;

                        }
                    });

                    actualPriceElement.innerHTML = "$" + totalPriceVarientPrice;

                    var totalSummaryElement = document.querySelector('.total_summary');
                    var actualPriceElement = totalSummaryElement.querySelector('.actual_multiple_variants_price');
                    var compareAtPriceElement = totalSummaryElement.querySelector('.comapare_at_price_multiple_variants_price');

                    actualPriceElement.textContent = totalPriceVarientPrice;
                    compareAtPriceElement.textContent = totalPriceCompare_atPrice;

                    comapare_at_price_multiple_variants_price.textContent = "$" + totalPriceCompare_atPrice;
                    if (totalPriceCompare_atPrice) {
                        comapare_at_price_multiple_variants_price.textContent = "$" + totalPriceCompare_atPrice;
                        compareAtPriceElement.style.display = 'flex';
                    }
                }

                var dataValue = checkbox.getAttribute('data-prop');

                console.log(">>>>>>>>>", dataValue)

            } else {
              var forProduct = document.getElementById('forProduct');
              forProduct.click();
             var clickTrigger = document.getElementById('clickTrigger');
                if (clickTrigger) {
                clickTrigger.addEventListener('click', function(event) {
                event.preventDefault();
                });
                clickTrigger.click();
                }
               secondChild.classList.remove('active');
                count--;
                checkbox.closest('.saving_20_off_target').classList.remove('activeClass');
                var dataValue = checkbox.getAttribute('data');
                console.log(">>aaaaaaaaaaaaaaaaaa>>>>a", dataValue)

                variantImages.forEach(function (element) {

                    if (element.getAttribute('data') === dataValue) {

                        element.classList.remove("active");
                    }
                });
                var activeContainer = document.querySelector(".select_your_package_multiple_variants.activeClass");
                var actualPriceElement = activeContainer.querySelector(".actual_multiple_variants_price");
                var comapare_at_price_multiple_variants_price = activeContainer.querySelector(".comapare_at_price_multiple_variants_price");
                if (activeContainer) {

                    var variantImages = activeContainer.querySelectorAll('.variant__img');

                    var totalPriceVarientPrice = 0;
                    var totalPriceCompare_atPrice = 0;

                    variantImages.forEach(function (variantImg) {
                        if (variantImg.classList.contains('active')) {

                            var varientPrice = variantImg.getAttribute('varient_price');
                            var varientCompare_atPrice = variantImg.getAttribute('varient_compare_at_price');
                            var numericValueCompare_atPrice = parseFloat(varientCompare_atPrice.replace(/[^\d.]/g, ''));
                            var numericValueVarientPrice = parseFloat(varientPrice.replace(/[^\d.]/g, ''));
                            totalPriceVarientPrice += numericValueVarientPrice;
                            totalPriceCompare_atPrice += numericValueCompare_atPrice;

                        }
                    });

                    actualPriceElement.innerHTML = "$" + totalPriceVarientPrice;

                    var totalSummaryElement = document.querySelector('.total_summary');
                    var actualPriceElement = totalSummaryElement.querySelector('.actual_multiple_variants_price');
                    var compareAtPriceElement = totalSummaryElement.querySelector('.comapare_at_price_multiple_variants_price');

                    actualPriceElement.textContent = totalPriceVarientPrice;
                    compareAtPriceElement.textContent = totalPriceCompare_atPrice;

                    comapare_at_price_multiple_variants_price.textContent = "$" + totalPriceCompare_atPrice;
                    if (totalPriceCompare_atPrice) {
                        comapare_at_price_multiple_variants_price.textContent = "$" + totalPriceCompare_atPrice;
                        compareAtPriceElement.style.display = 'flex';
                    } else {
                    }

                }
            }
        });
    });
    var saving_40_off_target_checkboxes = document.querySelectorAll(".saving_40_off_target input[type='checkbox']");

    saving_40_off_target_checkboxes.forEach(function (checkbox) {
     
        checkbox.addEventListener("click", function () {
            var sumList = document.querySelector('.sum_list');
            var select_your_package = document.querySelector('.select_your_package');
            var thirdChild = sumList.querySelector('.sum_list>li:nth-child(3)');
            var variantImages = document.querySelectorAll('.variant__img');
            saving_40_off_target_checkboxes.forEach(function (otherCheckbox) {
                if (otherCheckbox !== checkbox) {
                    otherCheckbox.checked = false;
                }
            });

            if (checkbox.checked) {
               
                var selected_change = document.querySelector(".selected_change");
                  if(selected_change){
                    selected_change.innerHTML="NEW | 1ST IN THE UK";
                  }
                  
                setTimeout(function () {
                    var clickTrigger = document.getElementById('clickTrigger');
                    if (clickTrigger) {
                    clickTrigger.addEventListener('click', function(event) {
                    event.preventDefault();
                    });
                    clickTrigger.click();
                    }
                }, 1000);
                count++;
                thirdChild.classList.add('active');
                select_your_package.classList.add("active");
                checkbox.closest('.saving_40_off_target').classList.add('activeClass');
                var dataValue = checkbox.getAttribute('data');
         
                console.log(">>aaaaaaaaaaaaaaaaaa>>>>a", dataValue, count)
                variantImages.forEach(function (element) {

                    if (element.getAttribute('data') === dataValue) {

                        element.classList.add("active");
                    }
                });
                var activeContainer = document.querySelector(".select_your_package_multiple_variants.activeClass");
                if (activeContainer) {
                    var actualPriceElement = activeContainer.querySelector(".actual_multiple_variants_price");
                }
                var comapare_at_price_multiple_variants_price = activeContainer.querySelector(".comapare_at_price_multiple_variants_price");
                if (activeContainer) {

                    var variantImages = activeContainer.querySelectorAll('.variant__img');

                    var totalPriceVarientPrice = 0;
                    var totalPriceCompare_atPrice = 0;

                    variantImages.forEach(function (variantImg) {
                        if (variantImg.classList.contains('active')) {

                            var varientPrice = variantImg.getAttribute('varient_price');
                            var varientCompare_atPrice = variantImg.getAttribute('varient_compare_at_price');
                            var numericValueCompare_atPrice = parseFloat(varientCompare_atPrice.replace(/[^\d.]/g, ''));
                            var numericValueVarientPrice = parseFloat(varientPrice.replace(/[^\d.]/g, ''));
                            totalPriceVarientPrice += numericValueVarientPrice;
                            totalPriceCompare_atPrice += numericValueCompare_atPrice;

                        }
                    });

                    actualPriceElement.innerHTML = "$" + totalPriceVarientPrice;

                    var totalSummaryElement = document.querySelector('.total_summary');
                    var actualPriceElement = totalSummaryElement.querySelector('.actual_multiple_variants_price');
                    var compareAtPriceElement = totalSummaryElement.querySelector('.comapare_at_price_multiple_variants_price');

                    actualPriceElement.textContent = totalPriceVarientPrice;
                    compareAtPriceElement.textContent = totalPriceCompare_atPrice;
                    comapare_at_price_multiple_variants_price.textContent = "$" + totalPriceCompare_atPrice;
                    if (totalPriceCompare_atPrice) {
                        comapare_at_price_multiple_variants_price.textContent = "$" + totalPriceCompare_atPrice;
                        compareAtPriceElement.style.display = 'flex';
                    } else {
                    }

                }
            } else {
           var selected_change = document.querySelector(".selected_change");
              if(selected_change){
                selected_change.innerHTML="Save 15%";
              }
              var forProduct = document.getElementById('forProduct');
              forProduct.click();
              var clickTrigger = document.getElementById('clickTrigger');
                if (clickTrigger) {
                clickTrigger.addEventListener('click', function(event) {
                event.preventDefault();
                });
                clickTrigger.click();
                }
                thirdChild.classList.remove('active');
                count--;
                checkbox.closest('.saving_40_off_target').classList.remove('activeClass');
                var dataValue = checkbox.getAttribute('data');

                variantImages.forEach(function (element) {

                    if (element.getAttribute('data') === dataValue) {

                        element.classList.remove("active");
                    }
                });

            }
            var activeContainer = document.querySelector(".select_your_package_multiple_variants.activeClass");
            var actualPriceElement = activeContainer.querySelector(".actual_multiple_variants_price");
            var comapare_at_price_multiple_variants_price = activeContainer.querySelector(".comapare_at_price_multiple_variants_price");
            if (activeContainer) {

                var variantImages = activeContainer.querySelectorAll('.variant__img');

                var totalPriceVarientPrice = 0;
                var totalPriceCompare_atPrice = 0;

                variantImages.forEach(function (variantImg) {
                    if (variantImg.classList.contains('active')) {

                        var varientPrice = variantImg.getAttribute('varient_price');
                        var varientCompare_atPrice = variantImg.getAttribute('varient_compare_at_price');
                        var numericValueCompare_atPrice = parseFloat(varientCompare_atPrice.replace(/[^\d.]/g, ''));
                        var numericValueVarientPrice = parseFloat(varientPrice.replace(/[^\d.]/g, ''));
                        totalPriceVarientPrice += numericValueVarientPrice;
                        totalPriceCompare_atPrice += numericValueCompare_atPrice;

                    }
                });

                actualPriceElement.innerHTML = "$" + totalPriceVarientPrice;
                var totalSummaryElement = document.querySelector('.total_summary');
                var actualPriceElement = totalSummaryElement.querySelector('.actual_multiple_variants_price');
                var compareAtPriceElement = totalSummaryElement.querySelector('.comapare_at_price_multiple_variants_price');

                actualPriceElement.textContent = totalPriceVarientPrice;
                compareAtPriceElement.textContent = totalPriceCompare_atPrice;

                comapare_at_price_multiple_variants_price.textContent = "$" + totalPriceCompare_atPrice;
                if (totalPriceCompare_atPrice) {
                    comapare_at_price_multiple_variants_price.textContent = "$" + totalPriceCompare_atPrice;
                    compareAtPriceElement.style.display = 'flex';
                } else {
                }

            }
        });
    });

    document.addEventListener('DOMContentLoaded', function () {
        var select_your_package_checkboxes = document.querySelectorAll(".select_your_package input[type='checkbox']");

        select_your_package_checkboxes.forEach(function (checkbox) {
            checkbox.addEventListener("click", function () {
                var sumList = document.querySelector('.sum_list');
                var firstChild = sumList.firstElementChild;
                var secondChild = sumList.querySelector('.sum_list>li:nth-child(2)');
                var thirdChild = sumList.querySelector('.sum_list>li:nth-child(3)');

                select_your_package_checkboxes.forEach(function (otherCheckbox) {
                    if (otherCheckbox !== checkbox) {
                        otherCheckbox.checked = false;
                    }
                });

                var variantImg = this.parentNode.querySelector('.variant__img');
                var actual_multiple_variants_price = this.closest('.select_your_package_multiple_variants').querySelector('.actual_multiple_variants_price');
                var washesValue = this.closest('.select_your_package_multiple_variants').querySelector('.select_your_package_multiple_variants_header>h3');

                var variantImages = document.querySelectorAll('.variant__img');

                document.querySelectorAll(".select_your_package_multiple_variants").forEach(function (element) {
                    element.classList.remove("activeClass");
                });
                if (checkbox.checked) {
                    sumList.classList.add('addClass');

                    var variantPrice = variantImg.getAttribute('varient_price');

                    firstChild.querySelector('.scent').innerHTML = washesValue.innerHTML;
                    secondChild.querySelector('.size').innerHTML = washesValue.innerHTML;
                    thirdChild.querySelector('.plan').innerHTML = washesValue.innerHTML;
                    actual_multiple_variants_price.textContent = variantPrice;
                }
                var parentElement = checkbox.closest(".select_your_package_multiple_variants");
                parentElement.classList.add("activeClass");
            });
        });
    });
    var frequencytimeCurrentValue = "";
    document.addEventListener('DOMContentLoaded', function () {
        var select_your_package_checkboxes = document.querySelectorAll(".select_your_package input[type='checkbox']");

        select_your_package_checkboxes.forEach(function (checkbox) {
            checkbox.addEventListener("click", function () {

                select_your_package_checkboxes.forEach(function (otherCheckbox) {
                    if (otherCheckbox !== checkbox) {
                        otherCheckbox.checked = false;
                    }
                });
                var variantImg = this.parentNode.querySelector('.variant__img');
                var actual_multiple_variants_price = this.closest('.select_your_package_multiple_variants').querySelector('.actual_multiple_variants_price');
                var dataPropValue = this.closest('.select_your_package_multiple_variants').getAttribute('data-prop');
                var frequencytimeValue = this.closest('.select_your_package_multiple_variants').getAttribute('frequencytime');
                frequencytimeCurrentValue=frequencytimeValue;
                var perwash = this.closest('.select_your_package_multiple_variants').getAttribute('perwash');
                var comapare_at_price_multiple_variants_price = this.closest('.select_your_package_multiple_variants').querySelector('.comapare_at_price_multiple_variants_price');

              
                if (checkbox.checked) {
                    var clickTrigger = document.getElementById('clickTriggerSub');
                    if (clickTrigger) {
                    clickTrigger.click();
                    this.classList.add('activeClass');
                    // $('html, body').animate({
                    // scrollTop: $("#select_your_package1").offset().top
                    // }, 100);
                    }

                    document.querySelector(".delevery_date_price").innerHTML="<span>Only <b>$"+perwash+"</b>  per wash</span>"
      
                    console.log("aaaaaaaaaaaaaaaaaaaaaaaaaAAA>>", dataPropValue,perwash)
                    var formatElement = document.getElementById("format");
                    var one_time_purchase = document.querySelector('.one_time_purchase');
                    formatElement.setAttribute("pack_data", dataPropValue);
                    one_time_purchase.setAttribute("pack_data", dataPropValue);
                    var totalSummaryElement = document.querySelector('.total_summary'); 
                    var subscription_plan_content = document.querySelector('.subscription_plan_content');
                    var subscriptionActualPriceElement = subscription_plan_content.querySelector('.actual_multiple_variants_price');
                    var subscriptionCompareAtPriceElement = subscription_plan_content.querySelector('.comapare_at_price_multiple_variants_price');
                    var actualPriceElement = totalSummaryElement.querySelector('.actual_multiple_variants_price');
                    var compareAtPriceElement = totalSummaryElement.querySelector('.comapare_at_price_multiple_variants_price');
                    var variantPrice = variantImg.getAttribute('varient_price');
                    var varient_compare_at_price = variantImg.getAttribute('varient_compare_at_price');
                    var actual_price_text = variantPrice.trim();
                    var comapare_at_price_text = varient_compare_at_price.trim();
                    var actual_price_value = parseFloat(actual_price_text.substring(1));
                    var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
                  
                    var half_price = actual_price_value / 2;
                    var compare_at_half_price = comapare_at_price_value / 2;
                  
                    actualPriceElement.textContent = "$" + variantPrice;
                    compareAtPriceElement.textContent = "$" + varient_compare_at_price;

                    var total_priceElement = document.querySelector('.price_per_wash');
                    var actualPriceElement1 = total_priceElement.querySelector('.actual_multiple_variants_price');
                    var compareAtPriceElement1 = total_priceElement.querySelector('.comapare_at_price_multiple_variants_price');
                    // actualPriceElement1.textContent = variantPrice;

                    // compareAtPriceElement1.textContent = varient_compare_at_price;
                    actual_multiple_variants_price.textContent = variantPrice;
                    comapare_at_price_multiple_variants_price.textContent = varient_compare_at_price;
                  var producttitle = document.getElementById("format").getAttribute("producttitle");
                  if (producttitle == 'Laundry Detergent (Fresh Linen) & Fabric Conditioner + Dishwasher Sheets Bundle') {
                  var actual_price_text = variantPrice.trim();
                  var comapare_at_price_text = varient_compare_at_price.trim();
                  var actual_price_value = parseFloat(actual_price_text.substring(1));
                  var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
                  var half_price = actual_price_value / 3;
                  var compare_at_half_price = comapare_at_price_value / 3;
                  document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = actual_price_text;
                  document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = subscriptionCompareAtPriceElement;
                  document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + perwash;
                  document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
                  }else if(producttitle == 'Laundry Detergent (Fragrance Free) & Fabric Conditioner + Dishwasher Sheets Bundle'){
                  var actual_price_text = variantPrice.trim();
                  var comapare_at_price_text = varient_compare_at_price.trim();
                  var actual_price_value = parseFloat(actual_price_text.substring(1));
                  var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
                  var half_price = actual_price_value / 3;
                  var compare_at_half_price = comapare_at_price_value / 3;
                  document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = actual_price_text;
                  document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = subscriptionCompareAtPriceElement;
                  document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + perwash;
                  document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
                  }else if(producttitle == 'Laundry Detergent (Fresh Linen) + Fabric Conditioner Bundle'|| producttitle == 'Laundry Detergent (Fragrance Free) + Fabric Conditioner Bundle' || producttitle == 'Laundry Detergent (Fresh Linen) + Dishwasher Sheets Bundle' || producttitle == 'Laundry Detergent (Fragrance Free) + Dishwasher Sheets Bundle'){
                  var actual_price_text = variantPrice.trim();
                  var comapare_at_price_text = varient_compare_at_price.trim();
                  var actual_price_value = parseFloat(actual_price_text.substring(1));
                  var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
                  var half_price = actual_price_value / 2;
                  var compare_at_half_price = comapare_at_price_value / 2;
                  document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = actual_price_text;
                  document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_half_price;
                  document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + perwash;
                  document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
                  }else{
                  document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = variantPrice;
                  document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = varient_compare_at_price;
                  document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + perwash;
                  document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
                  }
                    var activeContainer = document.querySelector(".select_your_package_multiple_variants.activeClass");

                    if (activeContainer) {

                        var variantImages = activeContainer.querySelectorAll('.variant__img');

                        var totalPriceVarientPrice = 0;
                        var totalPriceCompare_atPrice = 0;
                        var totalVarientId = [];

                        variantImages.forEach(function (variantImg) {
                            if (variantImg.classList.contains('active')) {

                                var varientPrice = variantImg.getAttribute('varient_price');
                                var varientCompare_atPrice = variantImg.getAttribute('varient_compare_at_price');
                                var varientCompare_atPrice1 = variantImg.getAttribute('varient_id');
                                var sellingplan_id = variantImg.getAttribute('sellingplan_id');
                                var numericValueCompare_atPrice = parseFloat(varientCompare_atPrice.replace(/[^\d.]/g, ''));
                                var numericValueVarientPrice = parseFloat(varientPrice.replace(/[^\d.]/g, ''));
                                totalPriceVarientPrice = numericValueVarientPrice;
                                totalPriceCompare_atPrice = numericValueCompare_atPrice;

                                appendShippingFrequency(varientCompare_atPrice1, sellingplan_id);

                            }
                        });
                        function appendShippingFrequency(value, sellinPlanIdVal) {

                            var buttonElement = document.getElementById("custom_checkout_btn");
                            buttonElement.setAttribute("all_varient_id", value);
                            
                        }

                        console.log("Total Price:", totalPriceVarientPrice);
                        actualPriceElement.textContent = "$" + totalPriceVarientPrice;
                        actual_multiple_variants_price.textContent = "$" + totalPriceVarientPrice;
                        subscriptionActualPriceElement.textContent = "$" + totalPriceVarientPrice
                        compareAtPriceElement.textContent = "$" + totalPriceCompare_atPrice;
                        document.querySelector(".one_time_purchase  .actual_multiple_variants_price").innerHTML = "$" + totalPriceCompare_atPrice;

                        if (totalPriceCompare_atPrice) {
                            subscriptionCompareAtPriceElement.textContent = "$" + totalPriceCompare_atPrice;
                            comapare_at_price_multiple_variants_price.textContent = "$" + totalPriceCompare_atPrice;

                            compareAtPriceElement.style.display = 'flex';
                            subscriptionCompareAtPriceElement.style.display = 'flex';
                        } else {
                            // subscriptionCompareAtPriceElement.style.display = 'none';
                            // compareAtPriceElement.style.display = 'none';
                        }

                    }

                }
              var selectElement = document.getElementById("format");
              selectElement.selectedIndex = frequencytimeValue;
              var event = new Event('change');
              selectElement.dispatchEvent(event);
                var parentElement = checkbox.closest(".select_your_package_multiple_variants");
                parentElement.classList.add("activeClass");
            });
        });
    });

  
    var subscriptionPlanContentElements = document.querySelectorAll(".new_product_right .subscription_plan_content");
    for (var i = 0; i < subscriptionPlanContentElements.length; i++) {
        subscriptionPlanContentElements[i].addEventListener("click", function () {
            var clickTrigger = document.getElementById('clickTriggerSub');
            if (clickTrigger) {
                clickTrigger.click();
                this.classList.add('activeClass');
            }
        });
    }

document.addEventListener("DOMContentLoaded", function () {
    var subscription_plan_custome_checkboxes = document.querySelectorAll(".sbscription_choose");

    subscription_plan_custome_checkboxes.forEach(function (checkboxContainer) {
        checkboxContainer.addEventListener("click", function (event) {
            // Remove activeClass from other checkbox containers
            subscription_plan_custome_checkboxes.forEach(function (otherCheckboxContainer) {
                if (otherCheckboxContainer !== checkboxContainer) {
                    otherCheckboxContainer.classList.remove("activeClass");
                }
            });

            // Add activeClass to the clicked checkbox container
            checkboxContainer.classList.add("activeClass");

            // Uncheck other checkboxes within the same container
            checkboxContainer.querySelectorAll("input[type='checkbox']").forEach(function (checkbox) {
                if (checkbox !== event.target) {
                    checkbox.checked = false;
                }
            });

            // Check the clicked checkbox
            var checkbox = checkboxContainer.querySelector("input[type='checkbox']");
            checkbox.checked = true;
        });
    });
});


    var available_items = [
        {
            variantId: 42486277079252,
            quantity: 1,
            properties: {
                shipping_interval_frequency: "1",
                shipping_interval_unit_type: "Months"
            }
        },
        {
            variantId: 42486277013716,
            quantity: 1,
            properties: {
                shipping_interval_frequency: "1",
                shipping_interval_unit_type: "Months"
            }
        }
    ];
    document.getElementById("format").addEventListener("change", function () {
        var selectedMonth = this.options[this.selectedIndex].text.split(' ')[0];
        var pack_data = this.getAttribute("pack_data");
        var producttitle = this.getAttribute("producttitle");
        var checkstepfirst = this.getAttribute("checkstepfirst").trim();
        console.log("selectedMonth>>>>", selectedMonth, pack_data);
        if (producttitle == 'Eco Laundry Detergent Sheets') {
            var selectElement = document.getElementById("selling_plan");
            var options = selectElement.getElementsByTagName("option");
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                var optionText = option.textContent.trim();
                var numberPattern = /\d+/;
                var match = optionText.match(numberPattern);
                if (match && match[0] === selectedMonth) {
                    var optionPackData = option.getAttribute("data-pack");
                    var variant_title = option.getAttribute("variant_title").trim();
                    if (optionPackData && optionPackData === pack_data && checkstepfirst === variant_title) {
                        var sellingPlanId = option.getAttribute("selling_plan_id");
                        var variant_id = option.getAttribute("variant_id");
                        // alert(variant_title,"==",checkstepfirst,"and",sellingPlanId,variant_id)
                        console.log("selling_plan_id for option with pack data " + pack_data + " and selected month " + selectedMonth + ": " + sellingPlanId,variant_id);
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        buttonElement.setAttribute("all_sellingplan_id", sellingPlanId);
                        buttonElement.setAttribute("all_varient_id", variant_id);
                    } else {
                        // Code to handle the case when the condition is not true
                        // You can add code here to perform any necessary actions
                        // For example, you can log a message or set default values
                        console.log("Condition not met for option with pack data " + pack_data + " and selected month " + selectedMonth,checkstepfirst,optionPackData,"==",pack_data);
                    }
                }
            }
        } else if (producttitle == 'Eco Fabric Conditioner Sheets') {
            var selectElement = document.getElementById("selling_plan3");
            var options = selectElement.getElementsByTagName("option");
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                var optionText = option.textContent.trim();
                var numberPattern = /\d+/;
                var match = optionText.match(numberPattern);
                if (match && match[0] === selectedMonth) {
                    var optionPackData = option.getAttribute("data-pack");
                    if (optionPackData && optionPackData === pack_data) {
                        var sellingPlanId = option.getAttribute("selling_plan_id");
                         var variant_id = option.getAttribute("variant_id");
                         var variant_id = option.getAttribute("variant_id");
                        console.log("selling_plan_id for option with pack data " + pack_data + " and selected month " + selectedMonth + ": " + sellingPlanId);
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        buttonElement.setAttribute("all_sellingplan_id", sellingPlanId);
                       buttonElement.setAttribute("all_varient_id", variant_id);
                    }
                }
            }
        } else if (producttitle == 'Eco Dishwasher Sheets') {
            var selectElement = document.getElementById("selling_plan2");
            var options = selectElement.getElementsByTagName("option");
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                var optionText = option.textContent.trim();
                var numberPattern = /\d+/;
                var match = optionText.match(numberPattern);
                if (match && match[0] === selectedMonth) {
                    var optionPackData = option.getAttribute("data-pack");
                    if (optionPackData && optionPackData === pack_data) {
                        var sellingPlanId = option.getAttribute("selling_plan_id");
                         var variant_id = option.getAttribute("variant_id");
                        var variant_id = option.getAttribute("variant_id");
                        console.log("selling_plan_id for option with pack data " + pack_data + " and selected month " + selectedMonth + ": " + sellingPlanId);
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        buttonElement.setAttribute("all_sellingplan_id", sellingPlanId);
                       buttonElement.setAttribute("all_varient_id", variant_id);
                     
                    }
                }
            }
        } else if (producttitle == 'Laundry Detergent (Fresh Linen) + Fabric Conditioner Bundle') {
            var selectElement = document.getElementById("selling_plan4");
            var options = selectElement.getElementsByTagName("option");
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                var optionText = option.textContent.trim();
                var numberPattern = /\d+/;
                var match = optionText.match(numberPattern);
                if (match && match[0] === selectedMonth) {
                    var optionPackData = option.getAttribute("data-pack");
                    if (optionPackData && optionPackData === pack_data) {
                        var sellingPlanId = option.getAttribute("selling_plan_id");
                         var variant_id = option.getAttribute("variant_id");
                        console.log("selling_plan_id for option with pack data " + pack_data + " and selected month " + selectedMonth + ": " + sellingPlanId);
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        buttonElement.setAttribute("all_sellingplan_id", sellingPlanId);
                       buttonElement.setAttribute("all_varient_id", variant_id);
                    }
                }
            }
        } else if (producttitle == 'Laundry Detergent (Fragrance Free) + Fabric Conditioner Bundle') {
            var selectElement = document.getElementById("selling_plan6");
            var options = selectElement.getElementsByTagName("option");
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                var optionText = option.textContent.trim();
                var numberPattern = /\d+/;
                var match = optionText.match(numberPattern);
                if (match && match[0] === selectedMonth) {
                    var optionPackData = option.getAttribute("data-pack");
                    if (optionPackData && optionPackData === pack_data) {
                        var sellingPlanId = option.getAttribute("selling_plan_id");
                         var variant_id = option.getAttribute("variant_id");
                        console.log("selling_plan_id for option with pack data " + pack_data + " and selected month " + selectedMonth + ": " + sellingPlanId);
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        buttonElement.setAttribute("all_sellingplan_id", sellingPlanId);
                       buttonElement.setAttribute("all_varient_id", variant_id);
                    }
                }
            }
        } else if (producttitle == 'Laundry Detergent (Fresh Linen) + Dishwasher Sheets Bundle') {
            var selectElement = document.getElementById("selling_plan5");
            var options = selectElement.getElementsByTagName("option");
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                var optionText = option.textContent.trim();
                var numberPattern = /\d+/;
                var match = optionText.match(numberPattern);
                if (match && match[0] === selectedMonth) {
                    var optionPackData = option.getAttribute("data-pack");
                    if (optionPackData && optionPackData === pack_data) {
                        var sellingPlanId = option.getAttribute("selling_plan_id");
                         var variant_id = option.getAttribute("variant_id");
                        console.log("selling_plan_id for option with pack data " + pack_data + " and selected month " + selectedMonth + ": " + sellingPlanId);
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        buttonElement.setAttribute("all_sellingplan_id", sellingPlanId);
                       buttonElement.setAttribute("all_varient_id", variant_id);
                    }
                }
            }
        } else if (producttitle == 'Laundry Detergent (Fragrance Free) + Dishwasher Sheets Bundle') {
            var selectElement = document.getElementById("selling_plan7");
            var options = selectElement.getElementsByTagName("option");
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                var optionText = option.textContent.trim();
                var numberPattern = /\d+/;
                var match = optionText.match(numberPattern);
                if (match && match[0] === selectedMonth) {
                    var optionPackData = option.getAttribute("data-pack");
                    if (optionPackData && optionPackData === pack_data) {
                        var sellingPlanId = option.getAttribute("selling_plan_id");
                         var variant_id = option.getAttribute("variant_id");
                        console.log("selling_plan_id for option with pack data " + pack_data + " and selected month " + selectedMonth + ": " + sellingPlanId);
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        buttonElement.setAttribute("all_sellingplan_id", sellingPlanId);
                       buttonElement.setAttribute("all_varient_id", variant_id);
                    }
                }
            }
        } else if (producttitle == 'Dishwasher Sheets + Fabric Conditioner Sheets') {
            var selectElement = document.getElementById("selling_plan10");
            var options = selectElement.getElementsByTagName("option");
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                var optionText = option.textContent.trim();
                var numberPattern = /\d+/;
                var match = optionText.match(numberPattern);
                if (match && match[0] === selectedMonth) {
                    var optionPackData = option.getAttribute("data-pack");
                    if (optionPackData && optionPackData === pack_data) {
                        var sellingPlanId = option.getAttribute("selling_plan_id");
                         var variant_id = option.getAttribute("variant_id");
                        console.log("selling_plan_id for option with pack data " + pack_data + " and selected month " + selectedMonth + ": " + sellingPlanId);
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        buttonElement.setAttribute("all_sellingplan_id", sellingPlanId);
                       buttonElement.setAttribute("all_varient_id", variant_id);
                    }
                }
            }
        } else if (producttitle == 'Laundry Detergent (Fresh Linen) & Fabric Conditioner + Dishwasher Sheets Bundle') {
            var selectElement = document.getElementById("selling_plan8");
            var options = selectElement.getElementsByTagName("option");
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                var optionText = option.textContent.trim();
                var numberPattern = /\d+/;
                var match = optionText.match(numberPattern);
                if (match && match[0] === selectedMonth) {
                    var optionPackData = option.getAttribute("data-pack");
                    if (optionPackData && optionPackData === pack_data) {
                        var sellingPlanId = option.getAttribute("selling_plan_id");
                         var variant_id = option.getAttribute("variant_id");
                        console.log("selling_plan_id for option with pack data " + pack_data + " and selected month " + selectedMonth + ": " + sellingPlanId);
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        buttonElement.setAttribute("all_sellingplan_id", sellingPlanId);
                       buttonElement.setAttribute("all_varient_id", variant_id);
                    }
                }
            }
        } else if (producttitle == 'Laundry Detergent (Fragrance Free) & Fabric Conditioner + Dishwasher Sheets Bundle') {
            var selectElement = document.getElementById("selling_plan9");
            var options = selectElement.getElementsByTagName("option");
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                var optionText = option.textContent.trim();
                var numberPattern = /\d+/;
                var match = optionText.match(numberPattern);
                if (match && match[0] === selectedMonth) {
                    var optionPackData = option.getAttribute("data-pack");
                    if (optionPackData && optionPackData === pack_data) {
                        var sellingPlanId = option.getAttribute("selling_plan_id");
                         var variant_id = option.getAttribute("variant_id");
                        console.log("selling_plan_id for option with pack data " + pack_data + " and selected month " + selectedMonth + ": " + sellingPlanId);
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        buttonElement.setAttribute("all_sellingplan_id", sellingPlanId);
                       buttonElement.setAttribute("all_varient_id", variant_id);
                    }
                }
            }
        }

    });
    function updateCartTotalPrice() {

        var actualPriceElement = document.querySelector('.actual_multiple_variants_price');

        var actualPrice = actualPriceElement.textContent;
        var actualPriceValue = parseFloat(actualPrice.replace('$', ''));
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                updates: {
                    note: 'Updated cart total price',
                    attributes: {
                        total_price: actualPriceValue
                    }
                }
            })
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to update cart total price.');
                }
            })
            .catch(error => {
                console.error('Error updating cart total price:', error);
            });
    }

    if (localStorage.getItem('myKey') === 'true') {
        localStorage.setItem('myKey', 'false');
        location.reload();
    }

    document.getElementById("custom_checkout_btn").addEventListener("click", function () {
        localStorage.setItem('myKey', 'true');
        console.log("Value 'true' added to localStorage.");
        var allVariantIds = this.getAttribute("all_varient_id").split(' ');
        var allSellingPlanIds = this.getAttribute("all_sellingplan_id").split(' ');
        var shippingIntervalFrequency = this.getAttribute("shipping_interval_frequency");
        var shippingProperties = {
            shipping_interval_frequency: shippingIntervalFrequency,
            shipping_interval_unit_type: "Months"
        };

        var available_items = allVariantIds.map(function (variantId, index) {
            return {
                variantId: variantId,
                quantity: 1,
                selling_plan: allSellingPlanIds[index],
            };
        });

        addToCart(0, available_items);
    });

    function addToCart(index, available_items) {
        if (index >= available_items.length) {
            triggerCheckout();
            return;
        }

        var item = available_items[index];

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: item.variantId,
                quantity: item.quantity,
                selling_plan: item.selling_plan
            })
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to add product to cart.');
                }
                addToCart(index + 1, available_items);
                console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>AAAAAAAAAAAAAAaaaaaaaaa", tem.selling_plan, item.variantId)
                updateCartTotalPrice();

            })
            .catch(error => {
                console.error('Error adding product to cart:', error);
            });
    }

    function triggerCheckout() {
        var checkoutButton = document.getElementById("CartDrawer-Checkout");
        checkoutButton.disabled = false;
        checkoutButton.click();
    }

    var oneTimePurchaseElement = document.querySelector(".new_product_right .subscription_plan_content input[type='checkbox']");
    oneTimePurchaseElement.addEventListener('click', function () {
        var subscriptionActualPriceElement = document.querySelector('.new_product_right .subscription_plan_content .actual_multiple_variants_price').innerHTML;
        var subscriptionCompareAtPriceElement = document.querySelector('.subscription_plan_content .comapare_at_price_multiple_variants_price').innerHTML;
        var producttitle = document.getElementById("format").getAttribute("producttitle");
        var one_time_purchase = document.querySelector('.new_product_right .one_time_purchase');
        var selectElement = document.getElementById("format");
        setTimeout(function () {
        selectElement.selectedIndex = frequencytimeCurrentValue;
        var event = new Event('change');
        selectElement.dispatchEvent(event);
        }, 1000);
        var one_time_purchase = document.querySelector('.one_time_purchase');
        var countLengthData =  parseInt(one_time_purchase.getAttribute("countLength"));
        var pack_dataData =  one_time_purchase.getAttribute("pack_data");
        var priceString = subscriptionActualPriceElement;
        var priceData = parseFloat(priceString.replace(/[^\d.-]/g, '')); 
        var dataPackData = parseInt(pack_dataData.trim(), 10); // Ensure base 10 for parsing
        
        console.log("price:", priceData, "data-pack:", dataPackData);
        if (!isNaN(priceData) && !isNaN(dataPackData) && dataPackData !== 0) {
        var per_wash = priceData / (dataPackData * countLengthData);
        console.log("per_wash", per_wash.toFixed(2));
        document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" +per_wash.toFixed(2);
        } else {
        console.error("Invalid priceData or data-pack value:", priceData, dataPackData);
        }
       one_time_purchase.classList.add('activeClass')
    if (producttitle == 'Laundry Detergent (Fresh Linen) & Fabric Conditioner + Dishwasher Sheets Bundle') {
      var actual_price_text = subscriptionActualPriceElement.trim();
      var comapare_at_price_text = subscriptionCompareAtPriceElement.trim();
      var actual_price_value = parseFloat(actual_price_text.substring(1));
      var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
      var half_price = actual_price_value / 3;
      var compare_at_half_price = comapare_at_price_value / 3;
      document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = subscriptionActualPriceElement;
      document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = subscriptionCompareAtPriceElement;
      // document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + half_price.toFixed(2);
      // document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
    }else if(producttitle == 'Laundry Detergent (Fragrance Free) & Fabric Conditioner + Dishwasher Sheets Bundle'){
      var actual_price_text = subscriptionActualPriceElement.trim();
      var comapare_at_price_text = subscriptionCompareAtPriceElement.trim();
      var actual_price_value = parseFloat(actual_price_text.substring(1));
      var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
      var half_price = actual_price_value / 3;
      var compare_at_half_price = comapare_at_price_value / 3;
      document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = subscriptionActualPriceElement;
      document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = subscriptionCompareAtPriceElement;
      // document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + half_price.toFixed(2);
      // document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
    }else if(producttitle == 'Laundry Detergent (Fresh Linen) + Fabric Conditioner Bundle'|| producttitle == 'Laundry Detergent (Fragrance Free) + Fabric Conditioner Bundle' || producttitle == 'Laundry Detergent (Fresh Linen) + Dishwasher Sheets Bundle' || producttitle == 'Laundry Detergent (Fragrance Free) + Dishwasher Sheets Bundle'){
      var actual_price_text = subscriptionActualPriceElement.trim();
      var comapare_at_price_text = subscriptionCompareAtPriceElement.trim();
      var actual_price_value = parseFloat(actual_price_text.substring(1));
      var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
      var half_price = actual_price_value / 2;
      var compare_at_half_price = comapare_at_price_value / 2;
      document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = subscriptionActualPriceElement;
      document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = "";
      // document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + half_price;
      // document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
    }else{
      document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = subscriptionActualPriceElement;
      document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = subscriptionCompareAtPriceElement;
      // document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = subscriptionActualPriceElement;
      // document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = subscriptionCompareAtPriceElement;
    }
    });
    var oneTimePurchaseElement = document.querySelector('.new_product_right .one_time_purchase');
        oneTimePurchaseElement.addEventListener('click', function () {
        var buttonElement = document.getElementById("custom_checkout_btn");
        var oneTimePrice = document.querySelector(".new_product_right .one_time_purchase  .actual_multiple_variants_price").innerHTML;
        var subscriptionActualPriceElement = document.querySelector('.subscription_plan_content .actual_multiple_variants_price').innerHTML;
        var subscriptionCompareAtPriceElement = document.querySelector('.subscription_plan_content .comapare_at_price_multiple_variants_price').innerHTML;
        var producttitle = document.getElementById("format").getAttribute("producttitle");
          var one_time_purchase = document.querySelector('.one_time_purchase');
          var countLengthData =  parseInt(one_time_purchase.getAttribute("countLength"));
          var pack_dataData =  one_time_purchase.getAttribute("pack_data");
          var priceString = oneTimePrice;
          var priceData = parseFloat(priceString.replace(/[^\d.-]/g, '')); 
          var dataPackData = parseInt(pack_dataData.trim(), 10); // Ensure base 10 for parsing
          
          console.log("price:", priceData, "data-pack:", dataPackData);
          if (!isNaN(priceData) && !isNaN(dataPackData) && dataPackData !== 0) {
              var per_wash = priceData / (dataPackData * countLengthData);
              console.log("per_wash", per_wash.toFixed(2));
            document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" +per_wash.toFixed(2);
          } else {
              console.error("Invalid priceData or data-pack value:", priceData, dataPackData);
          }
        buttonElement.setAttribute("all_sellingplan_id", '');
        console.log("One Time Purchase clicked");
    if (producttitle == 'Laundry Detergent (Fresh Linen) & Fabric Conditioner + Dishwasher Sheets Bundle') {
      var actual_price_text = subscriptionActualPriceElement.trim();
      var comapare_at_price_text = subscriptionCompareAtPriceElement.trim();
      var actual_price_value = parseFloat(actual_price_text.substring(1));
      var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
      var half_price = actual_price_value / 3;
      var compare_at_half_price = comapare_at_price_value / 3;
      document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = comapare_at_price_text;
      document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = "";
      // document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" +compare_at_half_price.toFixed(2);;
      // document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
    }else if(producttitle == 'Laundry Detergent (Fragrance Free) & Fabric Conditioner + Dishwasher Sheets Bundle'){
      var actual_price_text = subscriptionActualPriceElement.trim();
      var comapare_at_price_text = subscriptionCompareAtPriceElement.trim();
      var actual_price_value = parseFloat(actual_price_text.substring(1));
      var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
      var half_price = actual_price_value / 3;
      var compare_at_half_price = comapare_at_price_value / 3;
      document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = comapare_at_price_text;
      document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = "";
      // document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" +compare_at_half_price.toFixed(2);;
      // document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
    }else if(producttitle == 'Laundry Detergent (Fresh Linen) + Fabric Conditioner Bundle'|| producttitle == 'Laundry Detergent (Fragrance Free) + Fabric Conditioner Bundle' || producttitle == 'Laundry Detergent (Fresh Linen) + Dishwasher Sheets Bundle' || producttitle == 'Laundry Detergent (Fragrance Free) + Dishwasher Sheets Bundle'){
      var actual_price_text = subscriptionActualPriceElement.trim();
      var comapare_at_price_text = subscriptionCompareAtPriceElement.trim();
      var actual_price_value = parseFloat(actual_price_text.substring(1));
      var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
      var half_price = actual_price_value / 2;
      var compare_at_half_price = comapare_at_price_value / 2;
      document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = comapare_at_price_text;
      document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = "";
      // document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" +compare_at_half_price;
      // document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
    }else{
      document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = subscriptionCompareAtPriceElement;
      document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = "";
      // document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = subscriptionCompareAtPriceElement;
      // document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
    }
        
    });

   

    $(document).on('change','input.varianton', function () {
        // $('html, body').animate({
        // scrollTop: $("#select_your_package").offset().top
        // }, 0);
        if ($('.sbscription_choose').hasClass('activeClass')) {

        } else {
            $('.subscription_plan_custome .subscription_plan_content.sbscription_choose input').click();
        }
        var pack = $('.packs.cstm-target.activeClass').data('prop');
            var container = document.querySelector('.choose_four_products_content');
            if (container) {
            var checkboxes = container.querySelectorAll('.varianton');
            
            // Loop through each checkbox element
            checkboxes.forEach(function(checkbox) {
                if (checkbox.checked) {
                    var parentElement = checkbox.closest('.choose_four_products_varient');
                    var dataPropValue = parentElement.getAttribute('data-prop');
                    console.log('data-prop value:', dataPropValue);
                    getString = dataPropValue;
                }
            });
            } else {
            console.log('Container element not found.');
            }

        $('input.varianton:checked').each(function () {
            if ($('input.varianton:checked').length == 3) {
       
                var forthirdfreshproductdishwasher = $(this).closest('.cstm-target').attr('forthirdfreshproductdishwasher');
                var forThirdFragranceProductDishwasher = $(this).closest('.cstm-target').attr('forThirdFragranceProductDishwasher');
                var selectElement = document.getElementById("format");
                 var one_time_purchase = document.querySelector('.one_time_purchase');
                one_time_purchase.setAttribute("countLength", "3");
                setTimeout(function () {
                    selectElement.selectedIndex = 3;
                    var event = new Event('change');
                    selectElement.dispatchEvent(event);
                }, 1000);

                if (forthirdfreshproductdishwasher == 'Laundry Detergent (Fresh Linen) & Fabric Conditioner + Dishwasher Sheets Bundle' && getString == 'Fresh Linen') {
                    console.log("for three....................", forthirdfreshproductdishwasher);
                    selectElement.setAttribute("producttitle", forthirdfreshproductdishwasher);
                    console.log("tttttttttttttt");
                    $('#selling_plan8 option').each(function () {
                        var option = $(this);
                        var planName = option.data('plan-name');
                        var sellingPlanId = option.attr('selling_plan_id');
                        var variantId = option.attr('variant_id');
                        var price = option.attr('price');
                        var compare_at_price = option.attr('compare_at_price');
                        var percentageprice = option.attr('percentageprice');
                        var perwashvalue = option.attr('perwashvalue');
                        var dataPack = parseInt(option.attr('data-pack').trim());
                        var variantTitle = option.attr('variant_title').trim();
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        var priceString = option.attr('price');
                        var priceData = parseFloat(priceString.replace(/[^\d.-]/g, '')); 
                        var dataPackData = parseInt(option.attr('data-pack').trim(), 10);
                        console.log("price:", priceData, "data-pack:", dataPackData);
                        if (!isNaN(priceData) && !isNaN(dataPackData) && dataPackData !== 0) {
                            var per_wash = priceData / (dataPackData * 3);
                            console.log("per_wash", per_wash.toFixed(2));
                        } else {
                            console.error("Invalid priceData or data-pack value:", priceData, dataPackData);
                        }
                        if (variantTitle === forthirdfreshproductdishwasher) {

                            $('.select_your_package .cstm-target').each(function () {
                                var propValue = parseInt($(this).data('prop'));
                                if (propValue === dataPack) {
                                    console.log(propValue, "==", dataPack, sellingPlanId, variantId, price, compare_at_price);
                                    $(this).find(".actual_multiple_variants_price").html(price);
                                    $(this).find(".comapare_at_price_multiple_variants_price").html(compare_at_price);
                                    $(this).find(".variant__img").attr("varient_id", variantId);
                                    $(this).find(".variant__img").attr("varient_price", price);
                                    $(this).find(".variant__img").attr("varient_compare_at_price", compare_at_price);
                                    $(this).find(".variant__img").attr("sellingplan_id", sellingPlanId);
                                    $(this).find(".checked_sign_conetent:first").html('<img src="https://cdn.shopify.com/s/files/1/0631/6123/7716/files/check-marks.png?v=1709804100"><span> Only <b>$' + per_wash.toFixed(2) + '</b> per wash (up to 50% lower than big brands)</span>');
                                  
                                    buttonElement.setAttribute("all_varient_id", variantId);
                                    if (propValue == '120') {
                                        var subscription_plan_content = document.querySelector('.subscription_plan_content');
                                        var free_gift_bundle_content = document.querySelector('.free_gift_bundle');
                                        free_gift_bundle_content.classList.add('activeClass')
                                        var free_gift_product = document.querySelector('.free_gift_product');
                                        free_gift_product.classList.add('active')
                                        var subscriptionActualPriceElement = subscription_plan_content.querySelector('.actual_multiple_variants_price');
                                        var subscriptionCompareAtPriceElement = subscription_plan_content.querySelector('.comapare_at_price_multiple_variants_price');
                                        var actual_price_text = price.trim();
                                        var comapare_at_price_text = compare_at_price.trim();
                                        var actual_price_value = parseFloat(actual_price_text.substring(1));
                                        var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
                                        var half_price = actual_price_value / 3;
                                        var compare_at_half_price = comapare_at_price_value / 3;
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        document.querySelector(".subscription_plan_content  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".subscription_plan_content  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + per_wash.toFixed(2);
                                        document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
                                        document.querySelector(".one_time_purchase  .actual_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".delevery_date_price").innerHTML="<span>Only <b>$"+per_wash.toFixed(2)+  "</b> per wash</span>";
                                        }else if (propValue == '240') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '180') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '60') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '360') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }
                                }
                            });
                        } else {
                            console.log("for one product............", variantTitle, "==", variant_title);
                        }
                    });
                } else if (forThirdFragranceProductDishwasher == 'Laundry Detergent (Fragrance Free) & Fabric Conditioner + Dishwasher Sheets Bundle' && getString == 'Fragrance Free') {
                    selectElement.setAttribute("producttitle", forThirdFragranceProductDishwasher);
                    console.log("for two product1111..............", forThirdFragranceProductDishwasher);
                    $('#selling_plan9 option').each(function () {
                        var option = $(this);
                        var planName = option.data('plan-name');
                        var sellingPlanId = option.attr('selling_plan_id');
                        var variantId = option.attr('variant_id');
                        var price = option.attr('price');
                        var percentageprice = option.attr('percentageprice');
                        var perwashvalue = option.attr('perwashvalue');
                        var compare_at_price = option.attr('compare_at_price');
                        var dataPack = parseInt(option.attr('data-pack').trim());
                        var variantTitle = option.attr('variant_title').trim();
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        var priceString = option.attr('price');
                        var priceData = parseFloat(priceString.replace(/[^\d.-]/g, '')); 
                        var dataPackData = parseInt(option.attr('data-pack').trim(), 10); // Ensure base 10 for parsing
                        
                        console.log("price:", priceData, "data-pack:", dataPackData);
                        if (!isNaN(priceData) && !isNaN(dataPackData) && dataPackData !== 0) {
                            var per_wash = priceData / (dataPackData * 3);
                            console.log("per_wash", per_wash.toFixed(2));
                        } else {
                            console.error("Invalid priceData or data-pack value:", priceData, dataPackData);
                        }
                        if (variantTitle === forThirdFragranceProductDishwasher) {
                            $('.select_your_package .cstm-target').each(function () {
                                var propValue = parseInt($(this).data('prop'));
                                if (propValue === dataPack) {
                                    console.log(propValue, "==", dataPack, sellingPlanId, variantId, price, compare_at_price,"percentageprice:-",percentageprice);
                                    $(this).find(".actual_multiple_variants_price").html(price);
                                    $(this).find(".comapare_at_price_multiple_variants_price").html(compare_at_price);
                                    $(this).find(".variant__img").attr("varient_id", variantId);
                                    $(this).find(".variant__img").attr("varient_price", price);
                                    $(this).find(".variant__img").attr("varient_compare_at_price", compare_at_price);
                                    $(this).find(".variant__img").attr("sellingplan_id", sellingPlanId);
                                    $(this).find(".checked_sign_conetent:first").html('<img src="https://cdn.shopify.com/s/files/1/0631/6123/7716/files/check-marks.png?v=1709804100"> <span>Only <b>$' + per_wash.toFixed(2) + '</b> per wash (up to 50% lower than big brands)</span>');
                                  
                                    buttonElement.setAttribute("all_varient_id", variantId);
                                    if (propValue == '120') {
                                        var subscription_plan_content = document.querySelector('.subscription_plan_content');
                                        var subscriptionActualPriceElement = subscription_plan_content.querySelector('.actual_multiple_variants_price');
                                        var free_gift_bundle_content = document.querySelector('.free_gift_bundle');
                                        free_gift_bundle_content.classList.add('activeClass')
                                        var free_gift_product = document.querySelector('.free_gift_product');
                                        free_gift_product.classList.add('active')
                                        var subscriptionCompareAtPriceElement = subscription_plan_content.querySelector('.comapare_at_price_multiple_variants_price');
                                        var actual_price_text = price.trim();
                                        var comapare_at_price_text = compare_at_price.trim();
                                        var actual_price_value = parseFloat(actual_price_text.substring(1));
                                        var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
                                        var half_price = actual_price_value / 3;
                                        var compare_at_half_price = comapare_at_price_value / 3;
                                        document.querySelector(".subscription_plan_content  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".subscription_plan_content  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + per_wash.toFixed(2);
                                        document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
                                        document.querySelector(".one_time_purchase  .actual_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".delevery_date_price").innerHTML="<span>Only <b>$"+per_wash.toFixed(2)+  "<b> per wash</span>";
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                      }else if (propValue == '240') {
                                       $(this).attr("perwash",per_wash.toFixed(2))
                                      }else if (propValue == '180') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                      }else if (propValue == '60') {
                                       $(this).attr("perwash",per_wash.toFixed(2))
                                      }else if (propValue == '360') {
                                       $(this).attr("perwash",per_wash.toFixed(2))
                                      }
                                }
                            });
                        } else {
                            console.log("for one product............", variantTitle, "==", variant_title);
                        }
                    });
                }

            } else if ($('input.varianton:checked').length == 2) {
               var one_time_purchase = document.querySelector('.one_time_purchase');
                one_time_purchase.setAttribute("countLength", "2");
                var fortwofreshproductfabric = $(this).closest('.cstm-target').attr('fortwofreshproductfabric');
                var forlastProductDishwasher = $(this).closest('.cstm-target').attr('forlastProductDishwasher');                                                    
                var fortwofragranceproductfabric = $(this).closest('.cstm-target').attr('fortwofragranceproductfabric');
                var fortwofreshproductdishwasher = $(this).closest('.cstm-target').attr('fortwofreshproductdishwasher');
                var fortwofragranceproductdishwasher = $(this).closest('.cstm-target').attr('fortwofragranceproductdishwasher');
              
                var selectElement = document.getElementById("format");
                setTimeout(function () {
                    selectElement.selectedIndex = 3;
                    var event = new Event('change');
                    selectElement.dispatchEvent(event);
                }, 1000);
                if (fortwofreshproductfabric == 'Laundry Detergent (Fresh Linen) + Fabric Conditioner Bundle' && getString == 'Fresh Linen') {
                    selectElement.setAttribute("producttitle", fortwofreshproductfabric);
                    console.log("tttttttttttttt");
                    var free_gift_bundle_content = document.querySelector('.free_gift_bundle');
                    free_gift_bundle_content.classList.remove('activeClass')
                    var free_gift_product = document.querySelector('.free_gift_product');
                    free_gift_product.classList.remove('active')
                    $('#selling_plan4 option').each(function () {
                        var option = $(this);
                        var planName = option.data('plan-name');
                        var sellingPlanId = option.attr('selling_plan_id');
                        var variantId = option.attr('variant_id');
                        var price = option.attr('price');
                        var compare_at_price = option.attr('compare_at_price');
                        var percentageprice = option.attr('percentageprice');
                        var perwashvalue = option.attr('perwashvalue');
                        var dataPack = parseInt(option.attr('data-pack').trim());
                        var variantTitle = option.attr('variant_title').trim();
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        var priceString = option.attr('price');
                        var priceData = parseFloat(priceString.replace(/[^\d.-]/g, '')); 
                        var dataPackData = parseInt(option.attr('data-pack').trim(), 10); // Ensure base 10 for parsing
                        
                        console.log("price:", priceData, "data-pack:", dataPackData);
                        if (!isNaN(priceData) && !isNaN(dataPackData) && dataPackData !== 0) {
                            var per_wash = priceData / (dataPackData * 2);
                            console.log("per_wash", per_wash.toFixed(2));
                        } else {
                            console.error("Invalid priceData or data-pack value:", priceData, dataPackData);
                        }
                        if (variantTitle === fortwofreshproductfabric) {

                            $('.select_your_package .cstm-target').each(function () {
                                var propValue = parseInt($(this).data('prop'));
                                if (propValue === dataPack) {
                                    console.log(propValue, "==", dataPack, sellingPlanId, variantId, price, compare_at_price);
                                    $(this).find(".actual_multiple_variants_price").html(price);
                                    $(this).find(".comapare_at_price_multiple_variants_price").html(compare_at_price);
                                    $(this).find(".variant__img").attr("varient_id", variantId);
                                    $(this).find(".variant__img").attr("varient_price", price);
                                    $(this).find(".variant__img").attr("varient_compare_at_price", compare_at_price);
                                    $(this).find(".variant__img").attr("sellingplan_id", sellingPlanId);
                                    $(this).find(".checked_sign_conetent:first").html('<img src="https://cdn.shopify.com/s/files/1/0631/6123/7716/files/check-marks.png?v=1709804100"><span> Only <b>$' + per_wash.toFixed(2) + '</b> per wash (up to 50% lower than big brands)</span>');
                                  
                                    buttonElement.setAttribute("all_varient_id", variantId);
                                    if (propValue == '120') {
                                        var subscription_plan_content = document.querySelector('.subscription_plan_content');
                                        var subscriptionActualPriceElement = subscription_plan_content.querySelector('.actual_multiple_variants_price');
                                        var subscriptionCompareAtPriceElement = subscription_plan_content.querySelector('.comapare_at_price_multiple_variants_price');
                                        var actual_price_text = price.trim();
                                        var comapare_at_price_text = compare_at_price.trim();
                                        var actual_price_value = parseFloat(actual_price_text.substring(1));
                                        var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
                                        var half_price = actual_price_value / 2;
                                        var compare_at_half_price = comapare_at_price_value / 2;
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        console.log("Half Price:", half_price,compare_at_half_price);
                                        document.querySelector(".subscription_plan_content  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".subscription_plan_content  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".one_time_purchase  .actual_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + per_wash.toFixed(2);
                                        document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
                                        document.querySelector(".delevery_date_price").innerHTML="<span>Only <b>$"+per_wash.toFixed(2)+  "</b> per wash</span>";
                                        }else if (propValue == '240') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '180') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '60') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '360') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }
                                }
                            });
                        } else {
                            console.log("for one product............", variantTitle, "==", variant_title);
                        }
                    });
                } else if (fortwofragranceproductfabric == 'Laundry Detergent (Fragrance Free) + Fabric Conditioner Bundle' && getString == 'Fragrance Free') {
                    selectElement.setAttribute("producttitle", fortwofragranceproductfabric);
                    console.log("for two product1111..............", fortwofragranceproductfabric);
                    var free_gift_bundle_content = document.querySelector('.free_gift_bundle');
                    free_gift_bundle_content.classList.remove('activeClass')
                    var free_gift_product = document.querySelector('.free_gift_product');
                    free_gift_product.classList.remove('active')
                    $('#selling_plan6 option').each(function () {
                        var option = $(this);
                        var planName = option.data('plan-name');
                        var sellingPlanId = option.attr('selling_plan_id');
                        var variantId = option.attr('variant_id');
                        var price = option.attr('price');
                        var compare_at_price = option.attr('compare_at_price');
                        var percentageprice = option.attr('percentageprice');
                        var perwashvalue = option.attr('perwashvalue');
                        var dataPack = parseInt(option.attr('data-pack').trim());
                        var variantTitle = option.attr('variant_title').trim();
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        var priceString = option.attr('price');
                        var priceData = parseFloat(priceString.replace(/[^\d.-]/g, '')); 
                        var dataPackData = parseInt(option.attr('data-pack').trim(), 10); // Ensure base 10 for parsing
                        
                        console.log("price:", priceData, "data-pack:", dataPackData);
                        if (!isNaN(priceData) && !isNaN(dataPackData) && dataPackData !== 0) {
                            var per_wash = priceData / (dataPackData * 2);
                            console.log("per_wash", per_wash.toFixed(2));
                        } else {
                            console.error("Invalid priceData or data-pack value:", priceData, dataPackData);
                        }
                        if (variantTitle === fortwofragranceproductfabric) {
                            $('.select_your_package .cstm-target').each(function () {
                                var propValue = parseInt($(this).data('prop'));
                                if (propValue === dataPack) {
                                    console.log(propValue, "==", dataPack, sellingPlanId, variantId, price, compare_at_price);
                                    $(this).find(".actual_multiple_variants_price").html(price);
                                    $(this).find(".comapare_at_price_multiple_variants_price").html(compare_at_price);
                                    $(this).find(".variant__img").attr("varient_id", variantId);
                                    $(this).find(".variant__img").attr("varient_price", price);
                                    $(this).find(".variant__img").attr("varient_compare_at_price", compare_at_price);
                                    $(this).find(".variant__img").attr("sellingplan_id", sellingPlanId);
                                    $(this).find(".checked_sign_conetent:first").html('<img src="https://cdn.shopify.com/s/files/1/0631/6123/7716/files/check-marks.png?v=1709804100"><span>Only <b>$' + per_wash.toFixed(2) + '</b> per wash (up to 50% lower than big brands)</span>');
                                  
                                    buttonElement.setAttribute("all_varient_id", variantId);
                                    if (propValue == '120') {
                                        var subscription_plan_content = document.querySelector('.subscription_plan_content');
                                        var subscriptionActualPriceElement = subscription_plan_content.querySelector('.actual_multiple_variants_price');
                                        var subscriptionCompareAtPriceElement = subscription_plan_content.querySelector('.comapare_at_price_multiple_variants_price');
                                        var actual_price_text = price.trim();
                                        var comapare_at_price_text = compare_at_price.trim();
                                        var actual_price_value = parseFloat(actual_price_text.substring(1));
                                        var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
                                        var half_price = actual_price_value / 2;
                                        var compare_at_half_price = comapare_at_price_value / 2;
                                        document.querySelector(".subscription_plan_content  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".subscription_plan_content  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + per_wash.toFixed(2);
                                        document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
                                        document.querySelector(".one_time_purchase  .actual_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".delevery_date_price").innerHTML="<span>Only <b>$"+per_wash.toFixed(2)+  "</b> per wash</span>";
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '240') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '180') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '60') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '360') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }
                                }
                            });
                        } else {
                            console.log("for one product............", variantTitle, "==", variant_title);
                        }
                    });
                } else if (fortwofreshproductdishwasher == 'Laundry Detergent (Fresh Linen) + Dishwasher Sheets Bundle' && getString == 'Fresh Linen') {
                  // alert(fortwofreshproductdishwasher)
                    console.log("ttttttttttttttpppppppp");
                    selectElement.setAttribute("producttitle", fortwofreshproductdishwasher);
                    console.log("for two product1111..............", fortwofreshproductdishwasher);
                    var free_gift_bundle_content = document.querySelector('.free_gift_bundle');
                    free_gift_bundle_content.classList.add('activeClass')
                    var free_gift_product = document.querySelector('.free_gift_product');
                    free_gift_product.classList.add('active')
                    $('#selling_plan5 option').each(function () {
                        var option = $(this);
                        var planName = option.data('plan-name');
                        var sellingPlanId = option.attr('selling_plan_id');
                        var variantId = option.attr('variant_id');
                        var price = option.attr('price');
                        var compare_at_price = option.attr('compare_at_price');
                        var percentageprice = option.attr('percentageprice');
                        var perwashvalue = option.attr('perwashvalue');
                        var dataPack = parseInt(option.attr('data-pack').trim());
                        var variantTitle = option.attr('variant_title').trim();
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        var priceString = option.attr('price');
                        var priceData = parseFloat(priceString.replace(/[^\d.-]/g, '')); 
                        var dataPackData = parseInt(option.attr('data-pack').trim(), 10); // Ensure base 10 for parsing
                        
                        console.log("price:", priceData, "data-pack:", dataPackData);
                        if (!isNaN(priceData) && !isNaN(dataPackData) && dataPackData !== 0) {
                            var per_wash = priceData / (dataPackData * 2);
                            console.log("per_wash", per_wash.toFixed(2));
                        } else {
                            console.error("Invalid priceData or data-pack value:", priceData, dataPackData);
                        }
                        if (variantTitle === fortwofreshproductdishwasher) {
                            $('.select_your_package .cstm-target').each(function () {
                                var propValue = parseInt($(this).data('prop'));
                                if (propValue === dataPack) {
                                    console.log(propValue, "==", dataPack, sellingPlanId, variantId, price, compare_at_price);
                                    $(this).find(".actual_multiple_variants_price").html(price);
                                    $(this).find(".comapare_at_price_multiple_variants_price").html(compare_at_price);
                                    $(this).find(".variant__img").attr("varient_id", variantId);
                                    $(this).find(".variant__img").attr("varient_price", price);
                                    $(this).find(".variant__img").attr("varient_compare_at_price", compare_at_price);
                                    $(this).find(".variant__img").attr("sellingplan_id", sellingPlanId);
                                    $(this).find(".checked_sign_conetent:first").html('<img src="https://cdn.shopify.com/s/files/1/0631/6123/7716/files/check-marks.png?v=1709804100"><span>Only <b>$' + per_wash.toFixed(2) + '</b> per wash (up to 50% lower than big brands)</span>');
                                  
                                    buttonElement.setAttribute("all_varient_id", variantId);
                                    if (propValue == '120') {
                                        var subscription_plan_content = document.querySelector('.subscription_plan_content');
                                        var subscriptionActualPriceElement = subscription_plan_content.querySelector('.actual_multiple_variants_price');
                                        var subscriptionCompareAtPriceElement = subscription_plan_content.querySelector('.comapare_at_price_multiple_variants_price');
                                        var actual_price_text = price.trim();
                                        var comapare_at_price_text = compare_at_price.trim();
                                        var actual_price_value = parseFloat(actual_price_text.substring(1));
                                        var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
                                        var half_price = actual_price_value / 2;
                                        var compare_at_half_price = comapare_at_price_value / 2;
                                        document.querySelector(".subscription_plan_content  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".subscription_plan_content  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + per_wash.toFixed(2);
                                        document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
                                        document.querySelector(".one_time_purchase  .actual_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".delevery_date_price").innerHTML="<span>Only <b>$"+per_wash.toFixed(2)+  "</b> per wash</span>";
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '240') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '180') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '60') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '360') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }
                                }
                            });
                        } else {
                            console.log("for one product............", variantTitle, "==", variant_title);
                        }
                    });
                } else if (fortwofragranceproductdishwasher == 'Laundry Detergent (Fragrance Free) + Dishwasher Sheets Bundle' && getString == 'Fragrance Free') {
                    selectElement.setAttribute("producttitle", fortwofragranceproductdishwasher);
                    console.log("for two product1111..............", fortwofragranceproductdishwasher);
                    var free_gift_bundle_content = document.querySelector('.free_gift_bundle');
                    free_gift_bundle_content.classList.add('activeClass')
                    var free_gift_product = document.querySelector('.free_gift_product');
                    free_gift_product.classList.add('active')
                    $('#selling_plan7 option').each(function () {
                        var option = $(this);
                        var planName = option.data('plan-name');
                        var sellingPlanId = option.attr('selling_plan_id');
                        var variantId = option.attr('variant_id');
                        var price = option.attr('price');
                        var compare_at_price = option.attr('compare_at_price');
                        var percentageprice = option.attr('percentageprice');
                        var perwashvalue = option.attr('perwashvalue');
                        var dataPack = parseInt(option.attr('data-pack').trim());
                        var variantTitle = option.attr('variant_title').trim();
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        var priceString = option.attr('price');
                        var priceData = parseFloat(priceString.replace(/[^\d.-]/g, '')); 
                        var dataPackData = parseInt(option.attr('data-pack').trim(), 10); // Ensure base 10 for parsing
                        
                        console.log("price:", priceData, "data-pack:", dataPackData);
                        if (!isNaN(priceData) && !isNaN(dataPackData) && dataPackData !== 0) {
                            var per_wash = priceData / (dataPackData * 2);
                            console.log("per_wash", per_wash.toFixed(2));
                        } else {
                            console.error("Invalid priceData or data-pack value:", priceData, dataPackData);
                        }
                        if (variantTitle === fortwofragranceproductdishwasher) {
                            $('.select_your_package .cstm-target').each(function () {
                                var propValue = parseInt($(this).data('prop'));
                                if (propValue === dataPack) {
                                    console.log(propValue, "==", dataPack, sellingPlanId, variantId, price, compare_at_price);
                                    $(this).find(".actual_multiple_variants_price").html(price);
                                    $(this).find(".comapare_at_price_multiple_variants_price").html(compare_at_price);
                                    $(this).find(".variant__img").attr("varient_id", variantId);
                                    $(this).find(".variant__img").attr("varient_price", price);
                                    $(this).find(".variant__img").attr("varient_compare_at_price", compare_at_price);
                                    $(this).find(".variant__img").attr("sellingplan_id", sellingPlanId);
                                    $(this).find(".checked_sign_conetent:first").html('<img src="https://cdn.shopify.com/s/files/1/0631/6123/7716/files/check-marks.png?v=1709804100"> <span>Only <b>$' + per_wash.toFixed(2) + '</b> per wash (up to 50% lower than big brands)</span>');
                                  
                                    buttonElement.setAttribute("all_varient_id", variantId);
                                    if (propValue == '120') {
                                        var subscription_plan_content = document.querySelector('.subscription_plan_content');
                                        var subscriptionActualPriceElement = subscription_plan_content.querySelector('.actual_multiple_variants_price');
                                        var subscriptionCompareAtPriceElement = subscription_plan_content.querySelector('.comapare_at_price_multiple_variants_price');
                                        var actual_price_text = price.trim();
                                        var comapare_at_price_text = compare_at_price.trim();
                                        var actual_price_value = parseFloat(actual_price_text.substring(1));
                                        var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
                                        var half_price = actual_price_value / 2;
                                        var compare_at_half_price = comapare_at_price_value / 2;
                                        document.querySelector(".subscription_plan_content  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".subscription_plan_content  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + per_wash.toFixed(2);
                                        document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
                                        document.querySelector(".one_time_purchase  .actual_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".delevery_date_price").innerHTML="<span>Only <b>$"+per_wash.toFixed(2)+  "</b> per wash</span>";
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '240') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '180') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '60') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '360') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }
                                }
                            });
                        } else {
                            console.log("for one product............", variantTitle, "==", variant_title);
                        }
                    });
                } else if (forlastProductDishwasher == 'Dishwasher Sheets + Fabric Conditioner Sheets' && getString != 'Fragrance Free' && getString != 'Fresh Linen') {
                    selectElement.setAttribute("producttitle", forlastProductDishwasher);
                    console.log("for two product1111..............", forlastProductDishwasher);
                    $('#selling_plan10 option').each(function () {
                        var option = $(this);
                        var planName = option.data('plan-name');
                        var sellingPlanId = option.attr('selling_plan_id');
                        var variantId = option.attr('variant_id');
                        var price = option.attr('price');
                        var compare_at_price = option.attr('compare_at_price');
                        var percentageprice = option.attr('percentageprice');
                        var perwashvalue = option.attr('perwashvalue');
                        var dataPack = parseInt(option.attr('data-pack').trim());
                        var variantTitle = option.attr('variant_title').trim();
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        var priceString = option.attr('price');
                        var priceData = parseFloat(priceString.replace(/[^\d.-]/g, '')); 
                        var dataPackData = parseInt(option.attr('data-pack').trim(), 10); // Ensure base 10 for parsing
                        
                        console.log("price:", priceData, "data-pack:", dataPackData);
                        if (!isNaN(priceData) && !isNaN(dataPackData) && dataPackData !== 0) {
                            var per_wash = priceData / (dataPackData * 2);
                            console.log("per_wash", per_wash.toFixed(2));
                        } else {
                            console.error("Invalid priceData or data-pack value:", priceData, dataPackData);
                        }
                        if (variantTitle === forlastProductDishwasher) {
                            $('.select_your_package .cstm-target').each(function () {
                                var propValue = parseInt($(this).data('prop'));
                                if (propValue === dataPack) {
                                    console.log(propValue, "==", dataPack, sellingPlanId, variantId, price, compare_at_price);
                                    $(this).find(".actual_multiple_variants_price").html(price);
                                    $(this).find(".comapare_at_price_multiple_variants_price").html(compare_at_price);
                                    $(this).find(".variant__img").attr("varient_id", variantId);
                                    $(this).find(".variant__img").attr("varient_price", price);
                                    $(this).find(".variant__img").attr("varient_compare_at_price", compare_at_price);
                                    $(this).find(".variant__img").attr("sellingplan_id", sellingPlanId);
                                    $(this).find(".checked_sign_conetent:first").html('<img src="https://cdn.shopify.com/s/files/1/0631/6123/7716/files/check-marks.png?v=1709804100"><span> Only <b>$' + per_wash.toFixed(2) + '</b> per wash (up to 50% lower than big brands)</span>');
                                  
                                    buttonElement.setAttribute("all_varient_id", variantId);
                                    if (propValue == '120') {
                                        var subscription_plan_content = document.querySelector('.subscription_plan_content');
                                        var subscriptionActualPriceElement = subscription_plan_content.querySelector('.actual_multiple_variants_price');
                                        var subscriptionCompareAtPriceElement = subscription_plan_content.querySelector('.comapare_at_price_multiple_variants_price');
                                        var actual_price_text = price.trim();
                                        var comapare_at_price_text = compare_at_price.trim();
                                        var actual_price_value = parseFloat(actual_price_text.substring(1));
                                        var comapare_at_price_value = parseFloat(comapare_at_price_text.substring(1));
                                        var half_price = actual_price_value / 2;
                                        var compare_at_half_price = comapare_at_price_value / 2;
                                        document.querySelector(".subscription_plan_content  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".subscription_plan_content  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + per_wash.toFixed(2);
                                        document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
                                        document.querySelector(".one_time_purchase  .actual_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".delevery_date_price").innerHTML="<span>Only <b>$"+per_wash.toFixed(2)+  "</b> per wash</span>";
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '240') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '180') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '60') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '360') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }
                                }
                            });
                        } else {
                            console.log("for one product............", variantTitle, "==", variant_title);
                        }
                    });
                }
                } else if ($('input.varianton:checked').length == 1) {
                  var free_gift_bundle_content = document.querySelector('.free_gift_bundle');
                  free_gift_bundle_content.classList.remove('activeClass')
                  var free_gift_product = document.querySelector('.free_gift_product');
                  free_gift_product.classList.remove('active')
                  var product_title = $(this).closest('.cstm-target').attr('product_title');
                  var variant_title = $(this).closest('.cstm-target').data('prop').trim();
                  getString = variant_title;
                var selectElement = document.getElementById("format");      
                selectElement.setAttribute("producttitle", product_title);
                selectElement.setAttribute("checkStepFirst", getString);
                var one_time_purchase = document.querySelector('.one_time_purchase');
                one_time_purchase.setAttribute("countLength", "1");
                setTimeout(function () {
                    selectElement.selectedIndex = 3;
                    var event = new Event('change');
                    selectElement.dispatchEvent(event);
                }, 1000);

                if (product_title == 'Eco Laundry Detergent Sheets' && getString == 'Fresh Linen') {
                   
                    $('#selling_plan option').each(function () {
                        var option = $(this);
                        var planName = option.data('plan-name');
                        var sellingPlanId = option.attr('selling_plan_id');
                        var variantId = option.attr('variant_id');
                        var price = option.attr('price');
                        var percentageprice = option.attr('percentageprice');
                        var perwashvalue = option.attr('perwashvalue');
                        var compare_at_price = option.attr('compare_at_price');
                        var dataPack = parseInt(option.attr('data-pack').trim());
                        var variantTitle = option.attr('variant_title').trim();
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        var priceString = option.attr('price');
                        var priceData = parseFloat(priceString.replace(/[^\d.-]/g, '')); 
                        var dataPackData = parseInt(option.attr('data-pack').trim(), 10); // Ensure base 10 for parsing
                        
                        console.log("price:", priceData, "data-pack:", dataPackData);
                        if (!isNaN(priceData) && !isNaN(dataPackData) && dataPackData !== 0) {
                            var per_wash = priceData / (dataPackData * 1);
                            console.log("per_wash", per_wash.toFixed(2));
                        } else {
                            console.error("Invalid priceData or data-pack value:", priceData, dataPackData);
                        }
                  
                        if (variantTitle === variant_title) {
                            $('.select_your_package .cstm-target').each(function () {
                                var propValue = parseInt($(this).data('prop'));
                                if (propValue === dataPack) {
                                    console.log(propValue, "==", dataPack, sellingPlanId, variantId, price, compare_at_price,"percentageprice:-",percentageprice);
                                    $(this).find(".actual_multiple_variants_price").html(price);
                                    $(this).find(".comapare_at_price_multiple_variants_price").html(compare_at_price);
                                    $(this).find(".variant__img").attr("varient_id", variantId);
                                    $(this).find(".variant__img").attr("varient_price", price);
                                    $(this).find(".variant__img").attr("varient_compare_at_price", compare_at_price);
                                    $(this).find(".variant__img").attr("sellingplan_id", sellingPlanId);
                                    $(this).find(".checked_sign_conetent:first").html('<img src="https://cdn.shopify.com/s/files/1/0631/6123/7716/files/check-marks.png?v=1709804100"> <span>Only <b> $'+ per_wash.toFixed(2) + '</b> per wash (up to 50% lower than big brands)</span>');
                                  
                                    buttonElement.setAttribute("all_varient_id", variantId);
                                    if (propValue == '120') {
                                        var subscription_plan_content = document.querySelector('.subscription_plan_content');
                                        var subscriptionActualPriceElement = subscription_plan_content.querySelector('.actual_multiple_variants_price');
                                        var subscriptionCompareAtPriceElement = subscription_plan_content.querySelector('.comapare_at_price_multiple_variants_price');
                                        document.querySelector(".subscription_plan_content  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".subscription_plan_content  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + per_wash.toFixed(2);
                                        document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
                                        document.querySelector(".one_time_purchase  .actual_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".delevery_date_price").innerHTML="<span>Only <b>$"+per_wash.toFixed(2)+  "</b> per wash</span>";
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                    }else if (propValue == '240') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                    }else if (propValue == '180') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                    }else if (propValue == '60') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                    }else if (propValue == '360') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                    }
                                }
                            });
                        } else {
                            console.log("for one product............", variantTitle, "==", variant_title);
                        }
                    });
                }else if (product_title == 'Eco Laundry Detergent Sheets' && getString == 'Fragrance Free') {
                    $('#selling_plan option').each(function () {
                        var option = $(this);
                        var planName = option.data('plan-name');
                        var sellingPlanId = option.attr('selling_plan_id');
                        var variantId = option.attr('variant_id');
                        var price = option.attr('price');
                        var percentageprice = option.attr('percentageprice');
                        var perwashvalue = option.attr('perwashvalue');
                        var compare_at_price = option.attr('compare_at_price');
                        var dataPack = parseInt(option.attr('data-pack').trim());
                        var variantTitle = option.attr('variant_title').trim();
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        var priceString = option.attr('price');
                        var priceData = parseFloat(priceString.replace(/[^\d.-]/g, '')); 
                        var dataPackData = parseInt(option.attr('data-pack').trim(), 10); // Ensure base 10 for parsing
                        
                        console.log("price:", priceData, "data-pack:", dataPackData);
                        if (!isNaN(priceData) && !isNaN(dataPackData) && dataPackData !== 0) {
                            var per_wash = priceData / (dataPackData * 1);
                            console.log("per_wash", per_wash.toFixed(2));
                        } else {
                            console.error("Invalid priceData or data-pack value:", priceData, dataPackData);
                        }
                       // alert(variantTitle,"==",variant_title)
                        if (variantTitle === variant_title) {
                            $('.select_your_package .cstm-target').each(function () {
                                var propValue = parseInt($(this).data('prop'));
                                if (propValue === dataPack) {
                                    console.log(propValue, "==", dataPack, sellingPlanId, variantId, price, compare_at_price,"percentageprice:-",percentageprice);
                                    $(this).find(".actual_multiple_variants_price").html(price);
                                    $(this).find(".comapare_at_price_multiple_variants_price").html(compare_at_price);
                                    $(this).find(".variant__img").attr("varient_id", variantId);
                                    $(this).find(".variant__img").attr("varient_price", price);
                                    $(this).find(".variant__img").attr("varient_compare_at_price", compare_at_price);
                                    $(this).find(".variant__img").attr("sellingplan_id", sellingPlanId);
                                    $(this).find(".checked_sign_conetent:first").html('<img src="https://cdn.shopify.com/s/files/1/0631/6123/7716/files/check-marks.png?v=1709804100"> <span>Only <b> $'+ per_wash.toFixed(2) + '</b> per wash (up to 50% lower than big brands)</span>');
                                  
                                    buttonElement.setAttribute("all_varient_id", variantId);
                                    if (propValue == '120') {
                                        var subscription_plan_content = document.querySelector('.subscription_plan_content');
                                        var subscriptionActualPriceElement = subscription_plan_content.querySelector('.actual_multiple_variants_price');
                                        var subscriptionCompareAtPriceElement = subscription_plan_content.querySelector('.comapare_at_price_multiple_variants_price');
                                        document.querySelector(".subscription_plan_content  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".subscription_plan_content  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + per_wash.toFixed(2);
                                        document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
                                        document.querySelector(".one_time_purchase  .actual_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".delevery_date_price").innerHTML="<span>Only <b>$"+per_wash.toFixed(2)+  "</b> per wash</span>";
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                    }else if (propValue == '240') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                    }else if (propValue == '180') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                    }else if (propValue == '60') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                    }else if (propValue == '360') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                    }
                                }
                            });
                        } else {
                            console.log("for one product............", variantTitle, "==", variant_title);
                        }
                    });
                } else if (product_title == 'Eco Fabric Conditioner Sheets') {

                    $('#selling_plan3 option').each(function () {
                        var option = $(this);
                        var planName = option.data('plan-name');
                        var sellingPlanId = option.attr('selling_plan_id');
                        var variantId = option.attr('variant_id');
                        var price = option.attr('price');
                        var compare_at_price = option.attr('compare_at_price');
                      	var percentageprice = option.attr('percentageprice');
                        var perwashvalue = option.attr('perwashvalue');
                      
                        var dataPack = parseInt(option.attr('data-pack').trim());
                        var variantTitle = option.attr('variant_title').trim();
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        var priceString = option.attr('price');
                        var priceData = parseFloat(priceString.replace(/[^\d.-]/g, '')); 
                        var dataPackData = parseInt(option.attr('data-pack').trim(), 10); // Ensure base 10 for parsing
                        
                        console.log("price:", priceData, "data-pack:", dataPackData);
                        if (!isNaN(priceData) && !isNaN(dataPackData) && dataPackData !== 0) {
                            var per_wash = priceData / (dataPackData * 1);
                            console.log("per_wash", per_wash.toFixed(2));
                        } else {
                            console.error("Invalid priceData or data-pack value:", priceData, dataPackData);
                        }
                        if (variantTitle === variant_title) {

                            $('.select_your_package .cstm-target').each(function () {
                                var propValue = parseInt($(this).data('prop'));

                                if (propValue === dataPack) {
                                    console.log(propValue, "==", dataPack, sellingPlanId, variantId, price, compare_at_price);
                                    $(this).find(".actual_multiple_variants_price").html(price);
                                    $(this).find(".comapare_at_price_multiple_variants_price").html(compare_at_price);
                                    $(this).find(".variant__img").attr("varient_id", variantId);
                                    $(this).find(".variant__img").attr("varient_price", price);
                                    $(this).find(".variant__img").attr("varient_compare_at_price", compare_at_price);
                                    $(this).find(".variant__img").attr("sellingplan_id", sellingPlanId);
                                    $(this).find(".checked_sign_conetent:first").html('<img src="https://cdn.shopify.com/s/files/1/0631/6123/7716/files/check-marks.png?v=1709804100"> <span>Only <b> $' + per_wash.toFixed(2) + '</b> per wash (up to 50% lower than big brands)</span>');
                                  
                                    buttonElement.setAttribute("all_varient_id", variantId);
                                    if (propValue == '120') {
                                        var subscription_plan_content = document.querySelector('.subscription_plan_content');
                                        var subscriptionActualPriceElement = subscription_plan_content.querySelector('.actual_multiple_variants_price');
                                        var subscriptionCompareAtPriceElement = subscription_plan_content.querySelector('.comapare_at_price_multiple_variants_price');
                                        document.querySelector(".subscription_plan_content  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".subscription_plan_content  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + per_wash.toFixed(2);
                                        document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
                                        document.querySelector(".one_time_purchase  .actual_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".delevery_date_price").innerHTML="<span>Only <b>$"+per_wash.toFixed(2)+  "</b> per wash</span>";
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '240') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '180') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '60') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '360') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }
                                }
                            });
                        } else {
                            console.log("for one product............", variantTitle, "==", variant_title);
                        }
                    });
                } else if (product_title == 'Eco Dishwasher Sheets') {

                    $('#selling_plan2 option').each(function () {
                        var option = $(this);
                        var planName = option.data('plan-name');
                        var sellingPlanId = option.attr('selling_plan_id');
                        var variantId = option.attr('variant_id');
                        var price = option.attr('price');
                        var compare_at_price = option.attr('compare_at_price');
                      	var percentageprice = option.attr('percentageprice');
                        var perwashvalue = option.attr('perwashvalue');
                        var dataPack = parseInt(option.attr('data-pack').trim());
                        var variantTitle = option.attr('variant_title').trim();
                        var buttonElement = document.getElementById("custom_checkout_btn");
                        var priceString = option.attr('price');
                        var priceData = parseFloat(priceString.replace(/[^\d.-]/g, '')); 
                        var dataPackData = parseInt(option.attr('data-pack').trim(), 10); // Ensure base 10 for parsing
                        
                        console.log("price:", priceData, "data-pack:", dataPackData);
                        if (!isNaN(priceData) && !isNaN(dataPackData) && dataPackData !== 0) {
                            var per_wash = priceData / (dataPackData * 1);
                            console.log("per_wash", per_wash.toFixed(2));
                        } else {
                            console.error("Invalid priceData or data-pack value:", priceData, dataPackData);
                        }
                        if (variantTitle === variant_title) {

                            $('.select_your_package .cstm-target').each(function () {
                                var propValue = parseInt($(this).data('prop'));

                                if (propValue === dataPack) {
                                    console.log(propValue, "==", dataPack, sellingPlanId, variantId, price, compare_at_price);
                                    $(this).find(".actual_multiple_variants_price").html(price);
                                    $(this).find(".comapare_at_price_multiple_variants_price").html(compare_at_price);
                                    $(this).find(".variant__img").attr("varient_id", variantId);
                                    $(this).find(".variant__img").attr("varient_price", price);
                                    $(this).find(".variant__img").attr("varient_compare_at_price", compare_at_price);
                                    $(this).find(".variant__img").attr("sellingplan_id", sellingPlanId);
                                    $(this).find(".checked_sign_conetent:first").html('<img src="https://cdn.shopify.com/s/files/1/0631/6123/7716/files/check-marks.png?v=1709804100"> <span>Only <b> $' + per_wash.toFixed(2) + '</b> per wash (up to 50% lower than big brands)</span>');
                                  
                                    buttonElement.setAttribute("all_varient_id", variantId);
                                    if (propValue == '120') {
                                        var subscription_plan_content = document.querySelector('.subscription_plan_content');
                                        var subscriptionActualPriceElement = subscription_plan_content.querySelector('.actual_multiple_variants_price');
                                        var subscriptionCompareAtPriceElement = subscription_plan_content.querySelector('.comapare_at_price_multiple_variants_price');
                                        document.querySelector(".subscription_plan_content  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".subscription_plan_content  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = price;
                                        document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = compare_at_price;
                                        document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$" + per_wash.toFixed(2);
                                        document.querySelector(".price_per_wash  .comapare_at_price_multiple_variants_price").innerHTML = "";
                                        document.querySelector(".delevery_date_price").innerHTML="<span>Only <b>$"+per_wash.toFixed(2)+  "</b> per wash</span>";
                                        document.querySelector(".one_time_purchase  .actual_multiple_variants_price").innerHTML = compare_at_price;
                                       $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '240') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '180') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '60') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }else if (propValue == '360') {
                                        $(this).attr("perwash",per_wash.toFixed(2))
                                        }
                                }
                            });
                        } else {
                            console.log("for one product............", variantTitle, "==", variant_title);
                        }
                    });
                }
            } else {
                console.log("no product............")
            }

        })
      checkCountInput();
    })
/*================================ Trigger click event on the checkbox ===================================== */
  
  var packElements = document.querySelectorAll('.packs.cstm-target');
  
  if (packElements.length > 0) {
    packElements.forEach(function(pack) {
      pack.addEventListener('click', function() {
          packElements.forEach(function(otherPack) {
              otherPack.classList.remove('activeClass');
          });
          pack.classList.add('activeClass');
          console.log("Closest checkbox__checkmark:", pack.closest('.checkbox__checkmark'));
          var checkbox = pack.querySelector('input[type="checkbox"]');
          if (checkbox) {
              checkbox.click(); 
          }
      });
  });
  }
/* ================================== (input length === 0) function ==============================*/

function checkCountInput(){
     var allPackageVariants = document.querySelectorAll('.select_your_package_multiple_variants');
     if($('input.varianton:checked').length == 0){
     document.querySelector(".one_time_purchase  .actual_multiple_variants_price").innerHTML = "$"+ 0;
        document.querySelector(".total_summary  .actual_multiple_variants_price").innerHTML = "$"+ 0;
        document.querySelector(".total_summary  .comapare_at_price_multiple_variants_price").innerHTML = "$"+ 0;
        document.querySelector(".price_per_wash  .actual_multiple_variants_price").innerHTML = "$"+ 0;
        document.querySelector(".subscription_plan_content  .actual_multiple_variants_price").innerHTML = "$"+ 0;
        document.querySelector(".subscription_plan_content  .comapare_at_price_multiple_variants_price").innerHTML = "$"+ 0;
        var buttonElement = document.getElementById("custom_checkout_btn");
        buttonElement.setAttribute("all_varient_id", "");
        buttonElement.setAttribute("all_sellingplan_id", "");
        allPackageVariants.forEach(function (element) {
        element.classList.remove("activeClass");
      });
      $('.select_your_package .cstm-target').each(function (index, element) {
          var subscription_plan_content = document.querySelector('.subscription_plan_content');
          subscription_plan_content.classList.remove("activeClass");
           element.classList.remove("activeClass");
          var subscriptionActualPriceElements = element.querySelectorAll(".actual_multiple_variants_price");
          var subscriptionCompareAtPriceElements = element.querySelectorAll(".comapare_at_price_multiple_variants_price");
          
          subscriptionActualPriceElements.forEach(function (priceElement) {
              priceElement.innerHTML = "$0";
          });
          
          subscriptionCompareAtPriceElements.forEach(function (compareAtPriceElement) {
              compareAtPriceElement.innerHTML = "$0";
          });
      });

  }
}

/* ================================== (input length === 0) function ==============================*/

/*================================ Trigger click event on the checkbox ===================================== */
})();
$(function(){

/* ============================ onscrolling stiky scheckbox code =============================*/
function handleIntersection(entries) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            document.querySelector('.container_custome_checkbox_button').classList.remove('scrolled');
        } else {
            document.querySelector('.container_custome_checkbox_button').classList.add('scrolled');
        }
    });
}

// Function to detect scroll direction
let lastScrollTop = 0;
function detectScrollDirection() {
    let st = window.pageYOffset || document.documentElement.scrollTop;
    let direction = '';
    if (st > lastScrollTop) {
        direction = 'down';
    } else {
        direction = 'up';
    }
    lastScrollTop = st <= 0 ? 0 : st;
    return direction;
}

// Function to handle scroll and observe intersection
function handleScrollAndIntersection() {
    let scrollDirection = detectScrollDirection();
    if (scrollDirection === 'up') {
        document.querySelector('.wrapper').classList.add('active');
    } else {
        document.querySelector('.wrapper').classList.remove('active');
    }
}

// Intersection Observer setup
const observer = new IntersectionObserver(handleIntersection);
observer.observe(document.querySelector('.wrapper'));

// Event listener for scroll
window.addEventListener('scroll', handleScrollAndIntersection);

  
// var packCheckboxClicked = false;
// function handleIntersectionForPack(entries) {
//     entries.forEach(entry => {
//         if (entry.isIntersecting) {
//             if (!packCheckboxClicked) {
//                     var aboutElement = document.querySelector('[data-scroll="#about"]');
//                      document.querySelector('#packSection').classList.add('scrolled');
//                     // Add the "active" class to the element
//                     aboutElement.classList.add('active');
//                     packCheckboxClicked = true;
//             }
//         } else {
//             // If intersection ends, reset the packCheckboxClicked flag
//             // packCheckboxClicked = false;
//             document.querySelector('#packSection').classList.remove('scrolled');
           
//              // var aboutElement = document.querySelector('[data-scroll="#about"]');
//              // aboutElement.classList.remove('active');
//         }
//     });
// }

// var observerForPack = new IntersectionObserver(handleIntersectionForPack);
// observerForPack.observe(document.querySelector('#packSection'));

// let planCheckboxClicked = false;

// function handleIntersectionForPlan(entries) {
//     entries.forEach(entry => {
//         if (entry.isIntersecting) {
//             document.querySelector('#planSection').classList.remove('scrolled');
//             if (!planCheckboxClicked) {
//                     var aboutElement = document.querySelector('[data-scroll="#services"]');
                    
//                     // Add the "active" class to the element
//                     aboutElement.classList.add('active');
//                 // Set planCheckboxClicked to true after clicking the checkbox
//                 planCheckboxClicked = true;
//             }
//         } else {
//             document.querySelector('#planSection').classList.add('scrolled');
//         }
//     });
// }

// var observerForPlan = new IntersectionObserver(handleIntersectionForPlan);
// observerForPlan.observe(document.querySelector('#planSection'));

//  https://github.com/piersrueb/inViewport

const inViewport = (elem) => {
    let allElements = document.getElementsByTagName(elem);
    let windowHeight = window.innerHeight;
   
    const elems = () => {
        for (let i = 0; i < allElements.length; i++) {
            let viewportOffset = allElements[i].getBoundingClientRect();
            let top = viewportOffset.top;
            let inViewportSections = document.querySelectorAll('.choose_four_products section.in-viewport');

            // Check the height of the first section in the viewport
            let firstSectionHeight = 0;
            console.log("windowHeight", windowHeight, "top", top, "firstSectionHeight", firstSectionHeight);
          
            if (top < firstSectionHeight) {
                allElements[i].classList.add('in-viewport');
                if ($('.choose_four_products section.in-viewport').length === 1) {
                    console.log($('.section.in-viewport').length);
                    if (!document.querySelector('.step1class').classList.contains('active')) {
                        document.querySelector('.step1class').classList.add('active');
                    }
                    if (document.querySelector('.step2class').classList.contains('active')) {
                        document.querySelector('.step2class').classList.remove('active');
                    }
                   //document.querySelector('.step3class').classList.remove('active');
                } else if ($('.choose_four_products section.in-viewport').length === 2) {
                    if (!document.querySelector('.step2class').classList.contains('active')) {
                        document.querySelector('.step2class').classList.add('active');
                    }
                   document.querySelector('.step3class').classList.remove('active');
                }else if ($('.choose_four_products section.in-viewport').length === 3) {
                      console.log($('.section.in-viewport').length);
                      if (!document.querySelector('.step3class').classList.contains('active')) {
                          document.querySelector('.step3class').classList.add('active');
                      }
                     } 
              }else {
                allElements[i].classList.remove('in-viewport');
                if ($('.choose_four_products section.in-viewport').length === 1) {
                    console.log($('.section.in-viewport').length);
                    if (!document.querySelector('.step1class').classList.contains('active')) {
                        document.querySelector('.step1class').classList.add('active');
                    }
                  
                } else if ($('.choose_four_products section.in-viewport').length === 2) {
                    if (document.querySelector('.step2class').classList.contains('active')) {
                        document.querySelector('.step2class').classList.remove('active');
                    }

                  
                } else if ($('.choose_four_products section.in-viewport').length === 3) {
                    console.log($('.section.in-viewport').length);
                    if (document.querySelector('.step3class').classList.contains('active')) {
                      document.querySelector('.step3class').classList.remove('active');
                    }
                }
            }
        }
    };
    elems();
    window.addEventListener('scroll', elems);
};

inViewport('section');

  //  run the function on all section elements

// function addandremoveclass() {
  
  
// }


/* ============================ onscrolling stiky scheckbox code =============================*/
})


$(window).on('load', function() {  
$(".choose_four_products_varient input.varianton1").click();
$(".choose_four_products_varient input.varianton3").click();
$(".choose_four_products_varient input.varianton4").click();
$(".build-plan_main #orange-flavour input.varianton").click();
$(".build-plan_main #flow_down_2").click();
});



function onPageLoadComplete() {

}
window.addEventListener('load', onPageLoadComplete);